import er from "react-dom";
import { g as tr } from "./@contentful-cca97bae.js";
import ve from "react";
import { t as Re } from "./tinycolor2-e04834eb.js";
import { a as rr } from "./html2canvas-c76dc20e.js";
var bt = {}, Pe = {}, ye = {}, _e = {}, Te = {};
Object.defineProperty(Te, "__esModule", {
  value: !0
});
Te.config = void 0;
var nr = {
  barSize: 18,
  crossSize: 18,
  inputSize: 40,
  delay: 150,
  defaultColor: "rgba(175, 51, 242, 1)",
  defaultGradient: "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)"
};
Te.config = nr;
var He = {}, ft;
function ar() {
  if (ft)
    return He;
  ft = 1, Object.defineProperty(He, "__esModule", {
    value: !0
  }), He.gradientParser = void 0;
  var s = xe(), o = je();
  function l(f) {
    "@babel/helpers - typeof";
    return l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
      return typeof m;
    } : function(m) {
      return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
    }, l(f);
  }
  function k(f) {
    return R(f) || I(f) || C(f) || q();
  }
  function q() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function I(f) {
    if (typeof Symbol < "u" && f[Symbol.iterator] != null || f["@@iterator"] != null)
      return Array.from(f);
  }
  function R(f) {
    if (Array.isArray(f))
      return b(f);
  }
  function E(f, m) {
    return O(f) || A(f, m) || C(f, m) || H();
  }
  function H() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function C(f, m) {
    if (f) {
      if (typeof f == "string")
        return b(f, m);
      var r = Object.prototype.toString.call(f).slice(8, -1);
      if (r === "Object" && f.constructor && (r = f.constructor.name), r === "Map" || r === "Set")
        return Array.from(f);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
        return b(f, m);
    }
  }
  function b(f, m) {
    (m == null || m > f.length) && (m = f.length);
    for (var r = 0, t = new Array(m); r < m; r++)
      t[r] = f[r];
    return t;
  }
  function A(f, m) {
    var r = f == null ? null : typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
    if (r != null) {
      var t, e, n, i, p = [], u = !0, y = !1;
      try {
        if (n = (r = r.call(f)).next, m === 0) {
          if (Object(r) !== r)
            return;
          u = !1;
        } else
          for (; !(u = (t = n.call(r)).done) && (p.push(t.value), p.length !== m); u = !0)
            ;
      } catch (c) {
        y = !0, e = c;
      } finally {
        try {
          if (!u && r.return != null && (i = r.return(), Object(i) !== i))
            return;
        } finally {
          if (y)
            throw e;
        }
      }
      return p;
    }
  }
  function O(f) {
    if (Array.isArray(f))
      return f;
  }
  function w(f, m) {
    var r = Object.keys(f);
    if (Object.getOwnPropertySymbols) {
      var t = Object.getOwnPropertySymbols(f);
      m && (t = t.filter(function(e) {
        return Object.getOwnPropertyDescriptor(f, e).enumerable;
      })), r.push.apply(r, t);
    }
    return r;
  }
  function h(f) {
    for (var m = 1; m < arguments.length; m++) {
      var r = arguments[m] != null ? arguments[m] : {};
      m % 2 ? w(Object(r), !0).forEach(function(t) {
        v(f, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(r)) : w(Object(r)).forEach(function(t) {
        Object.defineProperty(f, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return f;
  }
  function v(f, m, r) {
    return m = S(m), m in f ? Object.defineProperty(f, m, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : f[m] = r, f;
  }
  function S(f) {
    var m = W(f, "string");
    return l(m) === "symbol" ? m : String(m);
  }
  function W(f, m) {
    if (l(f) !== "object" || f === null)
      return f;
    var r = f[Symbol.toPrimitive];
    if (r !== void 0) {
      var t = r.call(f, m || "default");
      if (l(t) !== "object")
        return t;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (m === "string" ? String : Number)(f);
  }
  var z = Re, j = function() {
    var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", r = {
      linearGradient: /^(-(webkit|o|ms|moz)-)?(linear-gradient)/i,
      repeatingLinearGradient: /^(-(webkit|o|ms|moz)-)?(repeating-linear-gradient)/i,
      radialGradient: /^(-(webkit|o|ms|moz)-)?(radial-gradient)/i,
      repeatingRadialGradient: /^(-(webkit|o|ms|moz)-)?(repeating-radial-gradient)/i,
      sideOrCorner: /^to (left (top|bottom)|right (top|bottom)|top (left|right)|bottom (left|right)|left|right|top|bottom)/i,
      extentKeywords: /^(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)/,
      positionKeywords: /^(left|center|right|top|bottom)/i,
      pixelValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))px/,
      percentageValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))%/,
      emValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))em/,
      angleValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))deg/,
      startCall: /^\(/,
      endCall: /^\)/,
      comma: /^,/,
      hexColor: /^#([0-9a-fA-F]+)/,
      literalColor: /^([a-zA-Z]+)/,
      rgbColor: /^rgb/i,
      spacedRgbColor: /^(\d{1,3})\s+(\d{1,3})\s+(\d{1,3})\s+\/\s+([0-1](\.\d+)?)/,
      rgbaColor: /^rgba/i,
      hslColor: /^hsl/i,
      hsvColor: /^hsv/i,
      number: /^(([0-9]*\.[0-9]+)|([0-9]+\.?))/
    };
    function t(D) {
      var U = new Error(m + ": " + D);
      throw U.source = m, U;
    }
    function e() {
      var D, U = n();
      m.length > 0 && t("Invalid input not EOF");
      var Q = U[0], ae = Q == null || (D = Q.colorStops) === null || D === void 0 ? void 0 : D.filter(function(ce) {
        return (0, o.isUpperCase)(ce.value);
      }).length, ue = function() {
        if (ae > 0)
          return Q;
        var he = function(me, Ie) {
          return Ie === 0 ? (0, s.high)(me) : (0, s.low)(me);
        };
        return h(h({}, Q), {}, {
          colorStops: Q.colorStops.map(function(we, me) {
            return h(h({}, we), {}, {
              value: he(we, me)
            });
          })
        });
      };
      return ue();
    }
    function n() {
      return T(i);
    }
    function i() {
      return p("linear-gradient", r.linearGradient, y) || p("repeating-linear-gradient", r.repeatingLinearGradient, y) || p("radial-gradient", r.radialGradient, d) || p("repeating-radial-gradient", r.repeatingRadialGradient, d);
    }
    function p(D, U, Q) {
      return u(U, function(ae) {
        var ue = Q();
        return ue && (ne(r.comma) || t("Missing comma before color stops")), {
          type: D,
          orientation: ue,
          colorStops: T(_)
        };
      });
    }
    function u(D, U) {
      var Q = ne(D);
      if (Q) {
        ne(r.startCall) || t("Missing (");
        var ae = U(Q);
        return ne(r.endCall) || t("Missing )"), ae;
      }
    }
    function y() {
      return c() || a();
    }
    function c() {
      return ee("directional", r.sideOrCorner, 1);
    }
    function a() {
      return ee("angular", r.angleValue, 1);
    }
    function d() {
      var D, U = g(), Q;
      return U && (D = [], D.push(U), Q = m, ne(r.comma) && (U = g(), U ? D.push(U) : m = Q)), D;
    }
    function g() {
      var D = P() || x();
      if (D)
        D.at = B();
      else {
        var U = M();
        if (U) {
          D = U;
          var Q = B();
          Q && (D.at = Q);
        } else {
          var ae = N();
          ae && (D = {
            type: "default-radial",
            at: ae
          });
        }
      }
      return D;
    }
    function P() {
      var D = ee("shape", /^(circle)/i, 0);
      return D && (D.style = re() || M()), D;
    }
    function x() {
      var D = ee("shape", /^(ellipse)/i, 0);
      return D && (D.style = $() || M()), D;
    }
    function M() {
      return ee("extent-keyword", r.extentKeywords, 1);
    }
    function B() {
      if (ee("position", /^at/, 0)) {
        var D = N();
        return D || t("Missing positioning value"), D;
      }
    }
    function N() {
      var D = V();
      if (D.x || D.y)
        return {
          type: "position",
          value: D
        };
    }
    function V() {
      return {
        x: $(),
        y: $()
      };
    }
    function T(D) {
      var U = D(), Q = [];
      if (U)
        for (Q.push(U); ne(r.comma); )
          U = D(), U ? Q.push(U) : t("One extra comma");
      return Q;
    }
    function _() {
      var D, U = L();
      return U || t("Expected color definition"), U.left = parseInt((D = $()) === null || D === void 0 ? void 0 : D.value), U;
    }
    function L() {
      return Y() || G() || Se() || ge() || K() || le();
    }
    function K() {
      var D = ee("literal", r.literalColor, 0);
      if (D != null && D.value) {
        var U = z(D == null ? void 0 : D.value).toRgb(), Q = U.r, ae = U.g, ue = U.b, ce = U.a;
        return {
          value: "rgba(".concat(Q, ", ").concat(ae, ", ").concat(ue, ", ").concat(ce, ")")
        };
      }
    }
    function Y() {
      var D = ee("hex", r.hexColor, 1);
      if (D != null && D.value) {
        var U = z(D == null ? void 0 : D.value).toRgb(), Q = U.r, ae = U.g, ue = U.b, ce = U.a;
        return {
          value: "rgba(".concat(Q, ", ").concat(ae, ", ").concat(ue, ", ").concat(ce, ")")
        };
      }
    }
    var J = function(U) {
      var Q = (0, o.isUpperCase)(U == null ? void 0 : U[0]), ae = T(te), ue = z({
        h: ae[0],
        s: ae[1],
        l: ae[2],
        a: ae[3] || 1
      }).toRgb(), ce = ue.r, he = ue.g, we = ue.b, me = ue.a;
      return {
        value: "".concat(Q ? "RGBA" : "rgba", "(").concat(ce, ", ").concat(he, ", ").concat(we, ", ").concat(me, ")")
      };
    };
    function G() {
      return u(r.hslColor, J);
    }
    var F = function(U) {
      var Q = (0, o.isUpperCase)(U == null ? void 0 : U[0]), ae = T(te), ue = z({
        h: ae[0],
        s: ae[1],
        v: ae[2],
        a: ae[3] || 1
      }).toRgb(), ce = ue.r, he = ue.g, we = ue.b, me = ue.a;
      return {
        value: "".concat(Q ? "RGBA" : "rgba", "(").concat(ce, ", ").concat(he, ", ").concat(we, ", ").concat(me, ")")
      };
    };
    function le() {
      return u(r.hsvColor, F);
    }
    var fe = function(U) {
      var Q = (0, o.isUpperCase)(U == null ? void 0 : U[0]), ae = ne(r.spacedRgbColor), ue = ae || [null].concat(k(T(te))), ce = E(ue, 5), he = ce[1], we = ce[2], me = ce[3], Ie = ce[4], Ae = Ie === void 0 ? 1 : Ie;
      return {
        value: "".concat(Q ? "RGBA" : "rgba", "(").concat(he, ", ").concat(we, ", ").concat(me, ", ").concat(Ae, ")")
      };
    };
    function ge() {
      return u(r.rgbColor, fe);
    }
    var Ce = function(U) {
      var Q = (0, o.isUpperCase)(U == null ? void 0 : U[0]);
      return {
        value: "".concat(Q ? "RGBA" : "rgba", "(").concat(T(te), ")")
      };
    };
    function Se() {
      return u(r.rgbaColor, Ce);
    }
    function te() {
      return ne(r.number)[1];
    }
    function $() {
      return ee("%", r.percentageValue, 1) || Z() || re();
    }
    function Z() {
      return ee("position-keyword", r.positionKeywords, 1);
    }
    function re() {
      return ee("px", r.pixelValue, 1) || ee("em", r.emValue, 1);
    }
    function ee(D, U, Q) {
      var ae = ne(U);
      if (ae)
        return {
          type: D,
          value: ae[Q]
        };
    }
    function ne(D) {
      var U, Q;
      return Q = /^[\n\r\t\s]+/.exec(m), Q && pe(Q[0].length), U = D.exec(m), U && pe(U[0].length), U;
    }
    function pe(D) {
      m = m.substr(D);
    }
    return e();
  };
  return He.gradientParser = j, He;
}
var st;
function xe() {
  if (st)
    return _e;
  st = 1, Object.defineProperty(_e, "__esModule", {
    value: !0
  }), _e.low = _e.high = _e.getColors = _e.formatInputValues = void 0;
  var s = Te, o = ar();
  s.config.defaultColor;
  var l = s.config.defaultGradient, k = function(C) {
    return C.value.toLowerCase();
  };
  _e.low = k;
  var q = function(C) {
    return C.value.toUpperCase();
  };
  _e.high = q;
  var I = function(C) {
    var b = C == null ? void 0 : C.includes("gradient");
    if (b) {
      var A = C == null ? void 0 : C.includes("conic"), O = !A && R() ? C : l;
      A && console.log("Sorry we cant handle conic gradients yet");
      var w = (0, o.gradientParser)(O);
      return w == null ? void 0 : w.colorStops;
    } else {
      var h = C;
      return [{
        value: h
      }];
    }
  };
  _e.getColors = I;
  var R = function(C) {
    return !0;
  }, E = function(C, b, A) {
    return isNaN(C) || C < b ? b : C > A ? A : C;
  };
  return _e.formatInputValues = E, _e;
}
var vt;
function je() {
  if (vt)
    return ye;
  vt = 1, Object.defineProperty(ye, "__esModule", {
    value: !0
  }), ye.compareGradients = void 0, ye.computePickerPosition = E, ye.computeSquareXY = R, ye.getGradientType = ye.getDegrees = void 0, ye.getHandleValue = I, ye.safeBounds = ye.isUpperCase = ye.getNewHsl = void 0;
  var s = xe(), o = Te, l = Re, k = o.config.barSize, q = o.config.crossSize;
  function I(h) {
    var v = A(h), S = v.offsetLeft, W = v.clientWidth, z = h.clientX - S - k / 2, j = W - 18, f = (0, s.formatInputValues)(z, 0, j);
    return Math.round(f / (j / 100));
  }
  function R(h, v, S) {
    var W = h[1] * 100, z = h[2] * 100, j = W * (z < 50 ? z : 100 - z) / 100, f = Math.round(200 * j / (z + j)) | 0, m = Math.round(j + z), r = v / 100 * f - q / 2, t = S - S / 100 * m - q / 2;
    return [r, t];
  }
  function E(h) {
    var v = A(h), S = v.offsetLeft, W = v.offsetTop, z = v.clientWidth, j = v.clientHeight, f = function() {
      var t = h.clientX - S - q / 2;
      return (0, s.formatInputValues)(t, -9, z - 10);
    }, m = function() {
      var t = h.clientY - W - q / 2;
      return (0, s.formatInputValues)(t, -9, j - 10);
    };
    return [f(), m()];
  }
  var H = function(v) {
    var S, W = v == null ? void 0 : v.split(",")[0];
    return parseInt(W == null || (S = W.split("(")[1]) === null || S === void 0 ? void 0 : S.slice(0, -3));
  };
  ye.getDegrees = H;
  var C = function(v) {
    return v == null ? void 0 : v.split("(")[0];
  };
  ye.getGradientType = C;
  var b = function(v, S, W, z, j) {
    j(v);
    var f = l({
      h: v,
      s: S,
      l: W
    }), m = f.toRgb(), r = m.r, t = m.g, e = m.b;
    return "rgba(".concat(r, ", ").concat(t, ", ").concat(e, ", ").concat(z, ")");
  };
  ye.getNewHsl = b;
  var A = function(v) {
    var S = v.target.parentNode.getBoundingClientRect(), W = v.target.className, z = W === "c-resize ps-rl" ? 15 : 0;
    return {
      offsetLeft: (S == null ? void 0 : S.x) + z,
      offsetTop: S == null ? void 0 : S.y,
      clientWidth: S == null ? void 0 : S.width,
      clientHeight: S == null ? void 0 : S.height
    };
  };
  ye.safeBounds = A;
  var O = function(v) {
    var S;
    return (v == null ? void 0 : v[0]) === (v == null || (S = v[0]) === null || S === void 0 ? void 0 : S.toUpperCase());
  };
  ye.isUpperCase = O;
  var w = function(v, S) {
    var W, z, j = v == null || (W = v.toLowerCase()) === null || W === void 0 ? void 0 : W.replaceAll(" ", ""), f = S == null || (z = S.toLowerCase()) === null || z === void 0 ? void 0 : z.replaceAll(" ", "");
    return j === f;
  };
  return ye.compareGradients = w, ye;
}
(function(s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = i, s.usePicker = p;
  var o = R(ve), l = je(), k = xe(), q = Te;
  function I(u) {
    if (typeof WeakMap != "function")
      return null;
    var y = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap();
    return (I = function(d) {
      return d ? c : y;
    })(u);
  }
  function R(u, y) {
    if (!y && u && u.__esModule)
      return u;
    if (u === null || E(u) !== "object" && typeof u != "function")
      return { default: u };
    var c = I(y);
    if (c && c.has(u))
      return c.get(u);
    var a = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var g in u)
      if (g !== "default" && Object.prototype.hasOwnProperty.call(u, g)) {
        var P = d ? Object.getOwnPropertyDescriptor(u, g) : null;
        P && (P.get || P.set) ? Object.defineProperty(a, g, P) : a[g] = u[g];
      }
    return a.default = u, c && c.set(u, a), a;
  }
  function E(u) {
    "@babel/helpers - typeof";
    return E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(y) {
      return typeof y;
    } : function(y) {
      return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
    }, E(u);
  }
  function H(u) {
    return A(u) || b(u) || h(u) || C();
  }
  function C() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function b(u) {
    if (typeof Symbol < "u" && u[Symbol.iterator] != null || u["@@iterator"] != null)
      return Array.from(u);
  }
  function A(u) {
    if (Array.isArray(u))
      return v(u);
  }
  function O(u, y) {
    return W(u) || S(u, y) || h(u, y) || w();
  }
  function w() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function h(u, y) {
    if (u) {
      if (typeof u == "string")
        return v(u, y);
      var c = Object.prototype.toString.call(u).slice(8, -1);
      if (c === "Object" && u.constructor && (c = u.constructor.name), c === "Map" || c === "Set")
        return Array.from(u);
      if (c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c))
        return v(u, y);
    }
  }
  function v(u, y) {
    (y == null || y > u.length) && (y = u.length);
    for (var c = 0, a = new Array(y); c < y; c++)
      a[c] = u[c];
    return a;
  }
  function S(u, y) {
    var c = u == null ? null : typeof Symbol < "u" && u[Symbol.iterator] || u["@@iterator"];
    if (c != null) {
      var a, d, g, P, x = [], M = !0, B = !1;
      try {
        if (g = (c = c.call(u)).next, y === 0) {
          if (Object(c) !== c)
            return;
          M = !1;
        } else
          for (; !(M = (a = g.call(c)).done) && (x.push(a.value), x.length !== y); M = !0)
            ;
      } catch (N) {
        B = !0, d = N;
      } finally {
        try {
          if (!M && c.return != null && (P = c.return(), Object(P) !== P))
            return;
        } finally {
          if (B)
            throw d;
        }
      }
      return x;
    }
  }
  function W(u) {
    if (Array.isArray(u))
      return u;
  }
  function z(u, y) {
    var c = Object.keys(u);
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(u);
      y && (a = a.filter(function(d) {
        return Object.getOwnPropertyDescriptor(u, d).enumerable;
      })), c.push.apply(c, a);
    }
    return c;
  }
  function j(u) {
    for (var y = 1; y < arguments.length; y++) {
      var c = arguments[y] != null ? arguments[y] : {};
      y % 2 ? z(Object(c), !0).forEach(function(a) {
        f(u, a, c[a]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(u, Object.getOwnPropertyDescriptors(c)) : z(Object(c)).forEach(function(a) {
        Object.defineProperty(u, a, Object.getOwnPropertyDescriptor(c, a));
      });
    }
    return u;
  }
  function f(u, y, c) {
    return y = m(y), y in u ? Object.defineProperty(u, y, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : u[y] = c, u;
  }
  function m(u) {
    var y = r(u, "string");
    return E(y) === "symbol" ? y : String(y);
  }
  function r(u, y) {
    if (E(u) !== "object" || u === null)
      return u;
    var c = u[Symbol.toPrimitive];
    if (c !== void 0) {
      var a = c.call(u, y || "default");
      if (E(a) !== "object")
        return a;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (y === "string" ? String : Number)(u);
  }
  var t = Re, e = q.config.crossSize, n = /* @__PURE__ */ (0, o.createContext)();
  function i(u) {
    var y = u.children, c = u.bounds, a = u.value, d = u.onChange, g = u.squareSize, P = u.squareHeight, x = u.hideOpacity, M = c == null ? void 0 : c.x, B = a == null ? void 0 : a.includes("gradient"), N = (0, l.getGradientType)(a), V = (0, l.getDegrees)(a), T = N === "linear-gradient" ? "".concat(V, "deg") : "circle", _ = (0, k.getColors)(a), L = _ == null ? void 0 : _.map(function(be, ie) {
      return j(j({}, be), {}, {
        index: ie
      });
    }), K = (L == null ? void 0 : L.filter(function(be) {
      return (0, l.isUpperCase)(be.value);
    })[0]) || L[0], Y = K == null ? void 0 : K.value, J = K == null ? void 0 : K.index, G = K == null ? void 0 : K.left, F = (0, o.useState)(t(Y)), le = O(F, 2), fe = le[0], ge = le[1], Ce = (0, o.useState)("rgb"), Se = O(Ce, 2), te = Se[0], $ = Se[1], Z = fe.toRgb(), re = Z.r, ee = Z.g, ne = Z.b, pe = Z.a, D = fe.toHsl(), U = D.h, Q = D.s, ae = D.l, ue = fe.toHsv(), ce = ue.s, he = ue.v, we = (0, o.useState)(Math.round(U)), me = O(we, 2), Ie = me[0], Ae = me[1], Be = Math.round(U), Dt = (0, l.computeSquareXY)([Be, Q, ae], g, P), nt = O(Dt, 2), Mt = nt[0], Gt = nt[1], Ht = (0, o.useState)([]), at = O(Ht, 2), qe = at[0], Lt = at[1], Wt = (0, o.useState)([]), ot = O(Wt, 2), Me = ot[0], jt = ot[1], Bt = (0, o.useState)(null), it = O(Bt, 2), lt = it[0], Ge = it[1], Ue = function(ie) {
      ie !== a && (B ? (0, l.compareGradients)(Me[0], a) || jt([a].concat(H(Me == null ? void 0 : Me.slice(0, 8)))) : Lt([a].concat(H(qe == null ? void 0 : qe.slice(0, 8)))), d(ie));
    };
    (0, o.useEffect)(function() {
      ge(t(Y)), Ae(Be);
    }, [Y, Be]);
    var Ve = function(ie) {
      var de = ie.sort(function(se, Ee) {
        return se.left - Ee.left;
      }), oe = de == null ? void 0 : de.map(function(se) {
        return "".concat(se == null ? void 0 : se.value, " ").concat(se.left, "%");
      });
      Ue("".concat(N, "(").concat(T, ", ").concat(oe.join(", "), ")"));
    }, ut = function(ie) {
      var de = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : G, oe = _ == null ? void 0 : _.filter(function(Ee) {
        return !(0, l.isUpperCase)(Ee.value);
      }), se = [{
        value: ie.toUpperCase(),
        left: de
      }].concat(H(oe));
      Ve(se);
    }, $e = function(ie) {
      B ? ut(ie) : Ue(ie);
    }, qt = function(ie) {
      var de = (0, l.getHandleValue)(ie) / 100, oe = "rgba(".concat(re, ", ").concat(ee, ", ").concat(ne, ", ").concat(de, ")");
      $e(oe);
    }, Vt = function(ie) {
      var de = (0, l.getHandleValue)(ie) * 3.6, oe = (0, l.getNewHsl)(de, Q, ae, pe, Ae);
      $e(oe);
    }, $t = function(ie, de) {
      var oe = (0, l.computePickerPosition)(ie, P), se = O(oe, 2), Ee = se[0], Fe = se[1], Kt = Math.min(Ee + e / 2, g - 1), Yt = Math.min(Fe + e / 2, P - 1), Ke = O(de.getImageData(Kt, Yt, 1, 1).data, 3), Xt = Ke[0], Zt = Ke[1], Jt = Ke[2], Qt = "rgba(".concat(Xt, ", ").concat(Zt, ", ").concat(Jt, ", ").concat(pe, ")");
      $e(Qt);
    }, ct = function(ie) {
      var de = _ == null ? void 0 : _.map(function(oe, se) {
        return j(j({}, oe), {}, {
          value: se === ie ? (0, k.high)(oe) : (0, k.low)(oe)
        });
      });
      Ve(de);
    }, zt = function(ie) {
      var de, oe = (0, l.getHandleValue)(ie, M), se = (de = [].concat(H(_.map(function(Ee) {
        return j(j({}, Ee), {}, {
          value: (0, k.low)(Ee)
        });
      })), [{
        value: Y,
        left: oe
      }])) === null || de === void 0 ? void 0 : de.sort(function(Ee, Fe) {
        return Ee.left - Fe.left;
      });
      Ve(se);
    }, Nt = function() {
      if ((_ == null ? void 0 : _.length) > 2) {
        var ie = _ == null ? void 0 : _.map(function(oe, se) {
          return j(j({}, oe), {}, {
            value: se === J - 1 ? (0, k.high)(oe) : (0, k.low)(oe)
          });
        }), de = ie == null ? void 0 : ie.filter(function(oe, se) {
          return se !== J;
        });
        Ve(de);
      }
    }, Ut = function() {
      J !== (_ == null ? void 0 : _.length) - 1 && ct(J + 1);
    };
    (0, o.useEffect)(function() {
      return window.addEventListener("click", dt), function() {
        window.removeEventListener("click", dt);
      };
    }, [lt, a]);
    var dt = function(ie) {
      var de, oe = ie == null || (de = ie.path) === null || de === void 0 ? void 0 : de.map(function(se) {
        return se.id;
      });
      oe != null && oe.includes("gradient-bar") ? Ge("gpoint") : oe != null && oe.includes("rbgcp-input") ? Ge("input") : oe != null && oe.includes("rbgcp-wrapper") ? Ge("picker") : Ge(null);
    }, Ft = {
      x: Mt,
      y: Gt,
      s: Q,
      l: ae,
      r: re,
      g: ee,
      b: ne,
      hue: Be,
      hsvS: ce,
      hsvV: he,
      value: a,
      colors: _,
      degrees: V,
      inFocus: lt,
      opacity: pe,
      onChange: d,
      addPoint: zt,
      inputType: te,
      nextPoint: Ut,
      tinyColor: fe,
      handleHue: Vt,
      setInFocus: Ge,
      isGradient: B,
      offsetLeft: M,
      squareSize: g,
      hideOpacity: x,
      handleColor: $t,
      currentLeft: G,
      deletePoint: Nt,
      internalHue: Ie,
      squareHeight: P,
      setInputType: $,
      gradientType: N,
      handleChange: $e,
      currentColor: Y,
      selectedColor: J,
      handleOpacity: qt,
      setInternalHue: Ae,
      previousColors: qe,
      handleGradient: ut,
      setSelectedColor: ct,
      internalOnChange: Ue,
      previousGraidents: Me
    };
    return /* @__PURE__ */ o.default.createElement(n.Provider, {
      value: Ft
    }, y);
  }
  function p() {
    return (0, o.useContext)(n);
  }
})(Pe);
var wt = {}, St = {}, et = {};
(function(s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.usePaintSat = s.usePaintLight = s.usePaintBright = s.default = void 0;
  var o = ve, l = Re, k = function(C, b) {
    (0, o.useEffect)(function() {
      var A, O = C == null || (A = C.current) === null || A === void 0 ? void 0 : A.getContext("2d", {
        willReadFrequently: !0
      });
      O.rect(0, 0, b, 14);
      for (var w = O.createLinearGradient(0, 0, b, 0), h = 0; h <= 360; h += 30)
        w.addColorStop(h / 360, "hsl(".concat(h, ", 100%, 50%)"));
      O.fillStyle = w, O.fill();
    }, [C, b]);
  }, q = k;
  s.default = q;
  var I = function(C, b, A, O) {
    (0, o.useEffect)(function() {
      var w, h = C == null || (w = C.current) === null || w === void 0 ? void 0 : w.getContext("2d", {
        willReadFrequently: !0
      });
      if (h) {
        h.rect(0, 0, O, 14);
        for (var v = h.createLinearGradient(0, 0, O, 0), S = 0; S <= 100; S += 10)
          v.addColorStop(S / 100, "hsl(".concat(b, ", ").concat(S, "%, ").concat(A, "%)"));
        h.fillStyle = v, h.fill();
      }
    }, [C, b, A, O]);
  };
  s.usePaintSat = I;
  var R = function(C, b, A, O) {
    (0, o.useEffect)(function() {
      var w, h = C == null || (w = C.current) === null || w === void 0 ? void 0 : w.getContext("2d", {
        willReadFrequently: !0
      });
      if (h) {
        h.rect(0, 0, O, 14);
        for (var v = h.createLinearGradient(0, 0, O, 0), S = 0; S <= 100; S += 10)
          v.addColorStop(S / 100, "hsl(".concat(b, ", ").concat(A, "%, ").concat(S, "%)"));
        h.fillStyle = v, h.fill();
      }
    }, [C, b, A, O]);
  };
  s.usePaintLight = R;
  var E = function(C, b, A, O) {
    (0, o.useEffect)(function() {
      var w, h = C == null || (w = C.current) === null || w === void 0 ? void 0 : w.getContext("2d", {
        willReadFrequently: !0
      });
      if (h) {
        h.rect(0, 0, O, 14);
        for (var v = h.createLinearGradient(0, 0, O, 0), S = 0; S <= 100; S += 10) {
          var W = l({
            h: b,
            s: A,
            v: S
          });
          v.addColorStop(S / 100, W.toHslString());
        }
        h.fillStyle = v, h.fill();
      }
    }, [C, b, A, O]);
  };
  s.usePaintBright = E;
})(et);
var X = {};
Object.defineProperty(X, "__esModule", {
  value: !0
});
X.psRl = X.opacityOverlay = X.npe = X.jsb = X.jfe = X.jc = X.inputWrap = X.inputLabel = X.inputDropdown = X.input = X.handle = X.gradientHandleWrap = X.gradientHandle = X.df = X.degreeInput = X.controlBtnsWrap = X.controlBtn = X.checkered = X.canvasWrapper = X.cResize = X.cCross = X.borderBox = X.ac = void 0;
var or = {
  display: "flex"
};
X.df = or;
var ir = {
  alignItems: "center"
};
X.ac = ir;
var lr = {
  justifyContent: "center"
};
X.jc = lr;
var ur = {
  justifyContent: "flex-end"
};
X.jfe = ur;
var cr = {
  justifyContent: "space-between"
};
X.jsb = cr;
var dr = {
  position: "relative"
};
X.psRl = dr;
var fr = {
  cursor: "crosshair"
};
X.cCross = fr;
var sr = {
  borderRadius: 6,
  overflow: "hidden",
  height: 294
};
X.canvasWrapper = sr;
var vr = {
  cursor: "ew-resize"
};
X.cResize = vr;
var pr = {
  position: "absolute",
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
  borderRadius: 10
};
X.opacityOverlay = pr;
var yr = {
  boxSizing: "border-box"
};
X.borderBox = yr;
var gr = {
  position: "absolute",
  border: "2px solid white",
  borderRadius: "50%",
  boxShadow: "0px 0px 3px rgba(0,0,0,.5)",
  width: 18,
  height: 18,
  zIndex: 1e3,
  transition: "all 10ms linear",
  boxSizing: "border-box"
};
X.handle = gr;
var hr = {
  position: "absolute",
  zIndex: 1e4,
  top: -2,
  outline: "none"
};
X.gradientHandleWrap = hr;
var mr = {
  border: "2px solid white",
  borderRadius: "50%",
  boxShadow: "0px 0px 3px rgba(0,0,0,.5)",
  width: 18,
  height: 18,
  boxSizing: "border-box"
};
X.gradientHandle = mr;
var br = {
  pointerEvents: "none"
};
X.npe = br;
var wr = {
  height: 24,
  borderRadius: 4,
  border: "none",
  outline: "none",
  textAlign: "center",
  width: 34,
  fontWeight: 500,
  color: "rgb(50, 49, 54)",
  fontSize: 13,
  background: "transparent"
};
X.degreeInput = wr;
var Sr = {
  height: 32,
  borderRadius: 6,
  border: "1px solid #bebebe",
  width: "100%",
  padding: 2,
  outline: "none",
  color: "black",
  fontWeight: 400,
  textAlign: "center",
  boxSizing: "border-box"
};
X.inputWrap = Sr;
var Or = {
  textAlign: "center",
  lineHeight: 1.2,
  fontWeight: 700,
  color: "rgb(86,86,86)",
  fontSize: 11
};
X.inputLabel = Or;
var Pr = {
  paddingLeft: 8,
  paddingRight: 8,
  lineHeight: 1,
  borderRadius: 4,
  fontWeight: 700,
  color: "",
  fontSize: 12,
  height: 24,
  transition: "all 160ms ease",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "rgba(255,255,255,0)",
  boxShadow: "1px 1px 3px rgba(0,0,0,0)"
};
X.controlBtn = Pr;
var Cr = {
  height: 28,
  background: "#e9e9f5",
  borderRadius: 6,
  padding: 2
};
X.controlBtnsWrap = Cr;
var _r = {
  position: "absolute",
  right: -2,
  top: 34,
  padding: 5,
  background: "#e9e9f5",
  zIndex: 1e8,
  borderRadius: 6,
  boxShadow: "1px 1px 14px 1px rgba(0,0,0,.25)"
};
X.inputDropdown = _r;
var Er = {
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
};
X.input = Er;
var kr = {
  // background: '-webkit-linear-gradient(45deg, rgba(0, 0, 0, 0.18) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.18) 75%, rgba(0, 0, 0, 0.18) 0), -webkit-linear-gradient(45deg, rgba(0, 0, 0, 0.18) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.18) 75%, rgba(0, 0, 0, 0.18) 0), white',
  // background: '-moz-linear-gradient(45deg, rgba(0, 0, 0, 0.18) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.18) 75%, rgba(0, 0, 0, 0.18) 0), -moz-linear-gradient(45deg, rgba(0, 0, 0, 0.18) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.18) 75%, rgba(0, 0, 0, 0.18) 0), white',
  background: "linear-gradient(45deg, rgba(0, 0, 0, 0.18) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.18) 75%, rgba(0, 0, 0, 0.18) 0), linear-gradient(45deg, rgba(0, 0, 0, 0.18) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.18) 75%, rgba(0, 0, 0, 0.18) 0), white",
  backgroundRepeat: "repeat, repeat",
  backgroundPosition: "0px 0, 7px 7px",
  WebkitTransformOrigin: "0 0 0",
  transformOrigin: "0 0 0",
  WebkitBackgroundOrigin: "padding-box, padding-box",
  backgroundOrigin: "padding-box, padding-box",
  WebkitBackgroundClip: "border-box, border-box",
  backgroundClip: "border-box, border-box",
  WebkitBackgroundSize: "14px 14px, 14px 14px",
  backgroundSize: "14px 14px, 14px 14px",
  WebkitBoxShadow: "none",
  boxShadow: "none",
  textShadow: "none",
  WebkitTransition: "none",
  MozTransition: "none",
  OTransition: "none",
  transition: "none",
  WebkitTransform: "scaleX(1) scaleY(1) scaleZ(1)",
  transform: "scaleX(1) scaleY(1) scaleZ(1)",
  borderRadius: 10
};
X.checkered = kr;
(function(s) {
  function o(r) {
    "@babel/helpers - typeof";
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, o(r);
  }
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = void 0;
  var l = H(ve), k = Pe, q = R(et), I = X;
  function R(r) {
    return r && r.__esModule ? r : { default: r };
  }
  function E(r) {
    if (typeof WeakMap != "function")
      return null;
    var t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap();
    return (E = function(i) {
      return i ? e : t;
    })(r);
  }
  function H(r, t) {
    if (!t && r && r.__esModule)
      return r;
    if (r === null || o(r) !== "object" && typeof r != "function")
      return { default: r };
    var e = E(t);
    if (e && e.has(r))
      return e.get(r);
    var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var p in r)
      if (p !== "default" && Object.prototype.hasOwnProperty.call(r, p)) {
        var u = i ? Object.getOwnPropertyDescriptor(r, p) : null;
        u && (u.get || u.set) ? Object.defineProperty(n, p, u) : n[p] = r[p];
      }
    return n.default = r, e && e.set(r, n), n;
  }
  function C(r, t) {
    var e = Object.keys(r);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(r);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(r, i).enumerable;
      })), e.push.apply(e, n);
    }
    return e;
  }
  function b(r) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t] != null ? arguments[t] : {};
      t % 2 ? C(Object(e), !0).forEach(function(n) {
        A(r, n, e[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : C(Object(e)).forEach(function(n) {
        Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(e, n));
      });
    }
    return r;
  }
  function A(r, t, e) {
    return t = O(t), t in r ? Object.defineProperty(r, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = e, r;
  }
  function O(r) {
    var t = w(r, "string");
    return o(t) === "symbol" ? t : String(t);
  }
  function w(r, t) {
    if (o(r) !== "object" || r === null)
      return r;
    var e = r[Symbol.toPrimitive];
    if (e !== void 0) {
      var n = e.call(r, t || "default");
      if (o(n) !== "object")
        return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(r);
  }
  function h(r, t) {
    return j(r) || z(r, t) || S(r, t) || v();
  }
  function v() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function S(r, t) {
    if (r) {
      if (typeof r == "string")
        return W(r, t);
      var e = Object.prototype.toString.call(r).slice(8, -1);
      if (e === "Object" && r.constructor && (e = r.constructor.name), e === "Map" || e === "Set")
        return Array.from(r);
      if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))
        return W(r, t);
    }
  }
  function W(r, t) {
    (t == null || t > r.length) && (t = r.length);
    for (var e = 0, n = new Array(t); e < t; e++)
      n[e] = r[e];
    return n;
  }
  function z(r, t) {
    var e = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
    if (e != null) {
      var n, i, p, u, y = [], c = !0, a = !1;
      try {
        if (p = (e = e.call(r)).next, t === 0) {
          if (Object(e) !== e)
            return;
          c = !1;
        } else
          for (; !(c = (n = p.call(e)).done) && (y.push(n.value), y.length !== t); c = !0)
            ;
      } catch (d) {
        a = !0, i = d;
      } finally {
        try {
          if (!c && e.return != null && (u = e.return(), Object(u) !== u))
            return;
        } finally {
          if (a)
            throw i;
        }
      }
      return y;
    }
  }
  function j(r) {
    if (Array.isArray(r))
      return r;
  }
  var f = function() {
    var t = (0, l.useRef)(null), e = (0, k.usePicker)(), n = e.handleHue, i = e.internalHue, p = e.squareSize, u = (0, l.useState)(!1), y = h(u, 2), c = y[0], a = y[1];
    (0, q.default)(t, p);
    var d = (0, l.useState)(2), g = h(d, 2), P = g[0], x = g[1];
    (0, l.useEffect)(function() {
      var T;
      x((t == null || (T = t.current) === null || T === void 0 ? void 0 : T.offsetTop) - 2);
    }, [t]);
    var M = function() {
      a(!1);
    }, B = function() {
      a(!0);
    }, N = function(_) {
      c && n(_);
    }, V = function(_) {
      c || n(_);
    };
    return (0, l.useEffect)(function() {
      var T = function() {
        M();
      };
      return window.addEventListener("mouseup", T), function() {
        window.removeEventListener("mouseup", T);
      };
    }, []), /* @__PURE__ */ l.default.createElement("div", {
      style: b(b(b(b({}, I.psRl), I.cResize), I.borderBox), {}, {
        height: 14,
        marginTop: 17,
        marginBottom: 4
      }),
      onMouseMove: function(_) {
        return N(_);
      }
    }, /* @__PURE__ */ l.default.createElement("div", {
      style: b(b({}, I.handle), {}, {
        left: i * ((p - 18) / 360),
        top: P
      }),
      onMouseDown: B
    }), /* @__PURE__ */ l.default.createElement("canvas", {
      ref: t,
      width: "".concat(p, "px"),
      height: "14px",
      style: {
        position: "relative",
        borderRadius: 14,
        verticalAlign: "top"
      },
      onClick: function(_) {
        return V(_);
      }
    }));
  }, m = f;
  s.default = m;
})(St);
var Ot = {}, De = {};
Object.defineProperty(De, "__esModule", {
  value: !0
});
De.cmykToRgb = void 0;
De.rgb2cmyk = Ar;
function Ar(s, o, l) {
  var k = 0, q = 0, I = 0, R = 0;
  if (s === null || o === null || l === null || isNaN(s) || isNaN(o) || isNaN(l)) {
    alert("Please enter numeric RGB values!");
    return;
  }
  if (s < 0 || o < 0 || l < 0 || s > 255 || o > 255 || l > 255) {
    alert("RGB values must be in the range 0 to 255.");
    return;
  }
  if (s === 0 && o === 0 && l === 0)
    return R = 1, [0, 0, 0, 1];
  k = 1 - s / 255, q = 1 - o / 255, I = 1 - l / 255;
  var E = Math.min(k, Math.min(q, I));
  return k = (k - E) / (1 - E), q = (q - E) / (1 - E), I = (I - E) / (1 - E), R = E, {
    c: k,
    m: q,
    y: I,
    k: R
  };
}
var Ir = function(o) {
  var l = o.c, k = o.m, q = o.y, I = o.k, R = 255 * (1 - l) * (1 - I), E = 255 * (1 - k) * (1 - I), H = 255 * (1 - q) * (1 - I);
  return {
    r: R,
    g: E,
    b: H
  };
};
De.cmykToRgb = Ir;
(function(s) {
  function o(c) {
    "@babel/helpers - typeof";
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
      return typeof a;
    } : function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, o(c);
  }
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = void 0;
  var l = H(ve), k = De, q = xe(), I = Pe, R = X;
  function E(c) {
    if (typeof WeakMap != "function")
      return null;
    var a = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap();
    return (E = function(P) {
      return P ? d : a;
    })(c);
  }
  function H(c, a) {
    if (!a && c && c.__esModule)
      return c;
    if (c === null || o(c) !== "object" && typeof c != "function")
      return { default: c };
    var d = E(a);
    if (d && d.has(c))
      return d.get(c);
    var g = {}, P = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var x in c)
      if (x !== "default" && Object.prototype.hasOwnProperty.call(c, x)) {
        var M = P ? Object.getOwnPropertyDescriptor(c, x) : null;
        M && (M.get || M.set) ? Object.defineProperty(g, x, M) : g[x] = c[x];
      }
    return g.default = c, d && d.set(c, g), g;
  }
  function C(c, a) {
    var d = Object.keys(c);
    if (Object.getOwnPropertySymbols) {
      var g = Object.getOwnPropertySymbols(c);
      a && (g = g.filter(function(P) {
        return Object.getOwnPropertyDescriptor(c, P).enumerable;
      })), d.push.apply(d, g);
    }
    return d;
  }
  function b(c) {
    for (var a = 1; a < arguments.length; a++) {
      var d = arguments[a] != null ? arguments[a] : {};
      a % 2 ? C(Object(d), !0).forEach(function(g) {
        A(c, g, d[g]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(d)) : C(Object(d)).forEach(function(g) {
        Object.defineProperty(c, g, Object.getOwnPropertyDescriptor(d, g));
      });
    }
    return c;
  }
  function A(c, a, d) {
    return a = O(a), a in c ? Object.defineProperty(c, a, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : c[a] = d, c;
  }
  function O(c) {
    var a = w(c, "string");
    return o(a) === "symbol" ? a : String(a);
  }
  function w(c, a) {
    if (o(c) !== "object" || c === null)
      return c;
    var d = c[Symbol.toPrimitive];
    if (d !== void 0) {
      var g = d.call(c, a || "default");
      if (o(g) !== "object")
        return g;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (a === "string" ? String : Number)(c);
  }
  function h(c, a) {
    return j(c) || z(c, a) || S(c, a) || v();
  }
  function v() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function S(c, a) {
    if (c) {
      if (typeof c == "string")
        return W(c, a);
      var d = Object.prototype.toString.call(c).slice(8, -1);
      if (d === "Object" && c.constructor && (d = c.constructor.name), d === "Map" || d === "Set")
        return Array.from(c);
      if (d === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(d))
        return W(c, a);
    }
  }
  function W(c, a) {
    (a == null || a > c.length) && (a = c.length);
    for (var d = 0, g = new Array(a); d < a; d++)
      g[d] = c[d];
    return g;
  }
  function z(c, a) {
    var d = c == null ? null : typeof Symbol < "u" && c[Symbol.iterator] || c["@@iterator"];
    if (d != null) {
      var g, P, x, M, B = [], N = !0, V = !1;
      try {
        if (x = (d = d.call(c)).next, a === 0) {
          if (Object(d) !== d)
            return;
          N = !1;
        } else
          for (; !(N = (g = x.call(d)).done) && (B.push(g.value), B.length !== a); N = !0)
            ;
      } catch (T) {
        V = !0, P = T;
      } finally {
        try {
          if (!N && d.return != null && (M = d.return(), Object(M) !== M))
            return;
        } finally {
          if (V)
            throw P;
        }
      }
      return B;
    }
  }
  function j(c) {
    if (Array.isArray(c))
      return c;
  }
  var f = Re, m = function() {
    var a = (0, I.usePicker)(), d = a.handleChange, g = a.r, P = a.g, x = a.b, M = a.opacity, B = a.inputType, N = a.hideOpacity;
    return /* @__PURE__ */ l.default.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        paddingTop: 14
      }
    }, B !== "cmyk" && /* @__PURE__ */ l.default.createElement(t, null), B === "hsl" && /* @__PURE__ */ l.default.createElement(n, null), B === "rgb" && /* @__PURE__ */ l.default.createElement(e, null), B === "hsv" && /* @__PURE__ */ l.default.createElement(i, null), B === "cmyk" && /* @__PURE__ */ l.default.createElement(p, null), !N && /* @__PURE__ */ l.default.createElement(u, {
      value: M * 100,
      callback: function(T) {
        return d("rgba(".concat(g, ", ").concat(P, ", ").concat(x, ", ").concat(T / 100, ")"));
      },
      label: "A"
    }));
  }, r = m;
  s.default = r;
  var t = function() {
    var a = (0, I.usePicker)(), d = a.handleChange, g = a.tinyColor, P = a.opacity, x = (0, l.useState)(""), M = h(x, 2), B = M[0], N = M[1], V = g.toHex(), T = (0, l.useState)(V), _ = h(T, 2), L = _[0], K = _[1];
    (0, l.useEffect)(function() {
      B !== "hex" && K(V);
    }, [g, B, V]);
    var Y = function() {
      N("hex");
    }, J = function() {
      N("");
    }, G = function(le) {
      var fe = f(le.target.value);
      if (K(le.target.value), fe.isValid()) {
        var ge = fe.toRgb(), Ce = ge.r, Se = ge.g, te = ge.b, $ = "rgba(".concat(Ce, ", ").concat(Se, ", ").concat(te, ", ").concat(P, ")");
        d($);
      }
    };
    return /* @__PURE__ */ l.default.createElement("div", {
      style: {
        width: "23%"
      }
    }, /* @__PURE__ */ l.default.createElement("input", {
      style: b({}, R.inputWrap),
      value: L,
      onChange: function(le) {
        return G(le);
      },
      id: "rbgcp-input",
      onFocus: Y,
      onBlur: J
    }), /* @__PURE__ */ l.default.createElement("div", {
      style: b({}, R.inputLabel)
    }, "HEX"));
  }, e = function() {
    var a = (0, I.usePicker)(), d = a.handleChange, g = a.r, P = a.g, x = a.b, M = a.opacity, B = function(V) {
      var T = V.r, _ = V.g, L = V.b;
      d("rgba(".concat(T, ", ").concat(_, ", ").concat(L, ", ").concat(M, ")"));
    };
    return /* @__PURE__ */ l.default.createElement(l.default.Fragment, null, /* @__PURE__ */ l.default.createElement(u, {
      value: g,
      callback: function(V) {
        return B({
          r: V,
          g: P,
          b: x
        });
      },
      label: "R",
      max: 255
    }), /* @__PURE__ */ l.default.createElement(u, {
      value: P,
      callback: function(V) {
        return B({
          r: g,
          g: V,
          b: x
        });
      },
      label: "G",
      max: 255
    }), /* @__PURE__ */ l.default.createElement(u, {
      value: x,
      callback: function(V) {
        return B({
          r: g,
          g: P,
          b: V
        });
      },
      label: "B",
      max: 255
    }));
  }, n = function() {
    var a = (0, I.usePicker)(), d = a.handleChange, g = a.s, P = a.l, x = a.internalHue, M = a.opacity, B = a.setInternalHue, N = function(_, L, K) {
      B(_);
      var Y = f({
        h: _,
        s: L,
        l: K
      }).toRgb(), J = Y.r, G = Y.g, F = Y.b;
      d("rgba(".concat(J, ", ").concat(G, ", ").concat(F, ", ").concat(M, ")"));
    }, V = function(_) {
      var L = f(_).toRgb(), K = L.r, Y = L.g, J = L.b;
      d("rgba(".concat(K, ", ").concat(Y, ", ").concat(J, ", ").concat(M, ")"));
    };
    return /* @__PURE__ */ l.default.createElement(l.default.Fragment, null, /* @__PURE__ */ l.default.createElement(u, {
      value: y(x),
      callback: function(_) {
        return N(_, g, P);
      },
      label: "H",
      max: 360
    }), /* @__PURE__ */ l.default.createElement(u, {
      value: y(g * 100),
      callback: function(_) {
        return V({
          h: x,
          s: _,
          l: P
        });
      },
      label: "S"
    }), /* @__PURE__ */ l.default.createElement(u, {
      value: y(P * 100),
      callback: function(_) {
        return V({
          h: x,
          s: g,
          l: _
        });
      },
      label: "L"
    }));
  }, i = function() {
    var a = (0, I.usePicker)(), d = a.handleChange, g = a.hsvS, P = a.hsvV, x = a.internalHue, M = a.setInternalHue, B = a.opacity, N = function(_, L, K) {
      M(_);
      var Y = f({
        h: _,
        s: L,
        v: K
      }).toRgb(), J = Y.r, G = Y.g, F = Y.b;
      d("rgba(".concat(J, ", ").concat(G, ", ").concat(F, ", ").concat(B, ")"));
    }, V = function(_) {
      var L = f(_).toRgb(), K = L.r, Y = L.g, J = L.b;
      d("rgba(".concat(K, ", ").concat(Y, ", ").concat(J, ", ").concat(B, ")"));
    };
    return /* @__PURE__ */ l.default.createElement(l.default.Fragment, null, /* @__PURE__ */ l.default.createElement(u, {
      value: y(x),
      callback: function(_) {
        return N(_, g, P);
      },
      label: "H",
      max: 360
    }), /* @__PURE__ */ l.default.createElement(u, {
      value: y(g * 100),
      callback: function(_) {
        return V({
          h: x,
          s: _,
          v: P
        });
      },
      label: "S"
    }), /* @__PURE__ */ l.default.createElement(u, {
      value: y(P * 100),
      callback: function(_) {
        return V({
          h: x,
          s: g,
          v: _
        });
      },
      label: "V"
    }));
  }, p = function() {
    var a = (0, I.usePicker)(), d = a.handleChange, g = a.r, P = a.g, x = a.b, M = a.opacity, B = (0, k.rgb2cmyk)(g, P, x), N = B.c, V = B.m, T = B.k, _ = B.y, L = function(Y) {
      var J = (0, k.cmykToRgb)(Y), G = J.r, F = J.g, le = J.b;
      d("rgba(".concat(G, ", ").concat(F, ", ").concat(le, ", ").concat(M, ")"));
    };
    return /* @__PURE__ */ l.default.createElement(l.default.Fragment, null, /* @__PURE__ */ l.default.createElement(u, {
      value: y(N * 100),
      callback: function(Y) {
        return L({
          c: Y,
          m: V,
          y: _,
          k: T
        });
      },
      label: "C"
    }), /* @__PURE__ */ l.default.createElement(u, {
      value: y(V * 100),
      callback: function(Y) {
        return L({
          c: N,
          m: Y,
          y: _,
          k: T
        });
      },
      label: "M"
    }), /* @__PURE__ */ l.default.createElement(u, {
      value: y(_ * 100),
      callback: function(Y) {
        return L({
          c: N,
          m: V,
          y: Y,
          k: T
        });
      },
      label: "Y"
    }), /* @__PURE__ */ l.default.createElement(u, {
      value: y(T * 100),
      callback: function(Y) {
        return L({
          c: N,
          m: V,
          y: _,
          k: Y
        });
      },
      label: "K"
    }));
  }, u = function(a) {
    var d = a.value, g = a.callback, P = a.max, x = P === void 0 ? 100 : P, M = a.label, B = (0, l.useState)(d), N = h(B, 2), V = N[0], T = N[1], _ = (0, I.usePicker)(), L = _.hideOpacity, K = L ? "22%" : "18%";
    (0, l.useEffect)(function() {
      T(d);
    }, [d]);
    var Y = function(G) {
      var F = (0, q.formatInputValues)(parseFloat(G.target.value), 0, x);
      T(F), g(F);
    };
    return /* @__PURE__ */ l.default.createElement("div", {
      style: {
        width: K
      }
    }, /* @__PURE__ */ l.default.createElement("input", {
      id: "rbgcp-input",
      style: b({}, R.inputWrap),
      value: V,
      onChange: function(G) {
        return Y(G);
      }
    }), /* @__PURE__ */ l.default.createElement("div", {
      style: b({}, R.inputLabel)
    }, M));
  }, y = function(a) {
    return Math.round(a, 2);
  };
})(Ot);
var Pt = {}, Ct = {};
(function(s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = void 0;
  var o = ve, l = function(I, R, E, H) {
    (0, o.useEffect)(function() {
      var C = I.current.getContext("2d", {
        willReadFrequently: !0
      });
      C.fillStyle = "hsl(".concat(R, ", 100%, 50%)"), C.fillRect(0, 0, E, H);
      var b = C.createLinearGradient(0, 0, E, 0);
      b.addColorStop(0, "rgba(255, 255, 255, 1)"), b.addColorStop(1, "rgba(255, 255, 255, 0)"), C.fillStyle = b, C.fillRect(0, 0, E, H);
      var A = C.createLinearGradient(0, 0, 0, H);
      A.addColorStop(0, "rgba(0, 0, 0, 0)"), A.addColorStop(1, "rgba(0, 0, 0, 1)"), C.fillStyle = A, C.fillRect(0, 0, E, H);
    }, [I, R, E, H]);
  }, k = l;
  s.default = k;
})(Ct);
(function(s) {
  function o(r) {
    "@babel/helpers - typeof";
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, o(r);
  }
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = void 0;
  var l = H(ve), k = R(Ct), q = Pe, I = X;
  function R(r) {
    return r && r.__esModule ? r : { default: r };
  }
  function E(r) {
    if (typeof WeakMap != "function")
      return null;
    var t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap();
    return (E = function(i) {
      return i ? e : t;
    })(r);
  }
  function H(r, t) {
    if (!t && r && r.__esModule)
      return r;
    if (r === null || o(r) !== "object" && typeof r != "function")
      return { default: r };
    var e = E(t);
    if (e && e.has(r))
      return e.get(r);
    var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var p in r)
      if (p !== "default" && Object.prototype.hasOwnProperty.call(r, p)) {
        var u = i ? Object.getOwnPropertyDescriptor(r, p) : null;
        u && (u.get || u.set) ? Object.defineProperty(n, p, u) : n[p] = r[p];
      }
    return n.default = r, e && e.set(r, n), n;
  }
  function C(r, t) {
    var e = Object.keys(r);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(r);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(r, i).enumerable;
      })), e.push.apply(e, n);
    }
    return e;
  }
  function b(r) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t] != null ? arguments[t] : {};
      t % 2 ? C(Object(e), !0).forEach(function(n) {
        A(r, n, e[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : C(Object(e)).forEach(function(n) {
        Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(e, n));
      });
    }
    return r;
  }
  function A(r, t, e) {
    return t = O(t), t in r ? Object.defineProperty(r, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = e, r;
  }
  function O(r) {
    var t = w(r, "string");
    return o(t) === "symbol" ? t : String(t);
  }
  function w(r, t) {
    if (o(r) !== "object" || r === null)
      return r;
    var e = r[Symbol.toPrimitive];
    if (e !== void 0) {
      var n = e.call(r, t || "default");
      if (o(n) !== "object")
        return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(r);
  }
  function h(r, t) {
    return j(r) || z(r, t) || S(r, t) || v();
  }
  function v() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function S(r, t) {
    if (r) {
      if (typeof r == "string")
        return W(r, t);
      var e = Object.prototype.toString.call(r).slice(8, -1);
      if (e === "Object" && r.constructor && (e = r.constructor.name), e === "Map" || e === "Set")
        return Array.from(r);
      if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))
        return W(r, t);
    }
  }
  function W(r, t) {
    (t == null || t > r.length) && (t = r.length);
    for (var e = 0, n = new Array(t); e < t; e++)
      n[e] = r[e];
    return n;
  }
  function z(r, t) {
    var e = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
    if (e != null) {
      var n, i, p, u, y = [], c = !0, a = !1;
      try {
        if (p = (e = e.call(r)).next, t === 0) {
          if (Object(e) !== e)
            return;
          c = !1;
        } else
          for (; !(c = (n = p.call(e)).done) && (y.push(n.value), y.length !== t); c = !0)
            ;
      } catch (d) {
        a = !0, i = d;
      } finally {
        try {
          if (!c && e.return != null && (u = e.return(), Object(u) !== u))
            return;
        } finally {
          if (a)
            throw i;
        }
      }
      return y;
    }
  }
  function j(r) {
    if (Array.isArray(r))
      return r;
  }
  var f = function() {
    var t = (0, q.usePicker)(), e = t.x, n = t.y, i = t.handleColor, p = t.internalHue, u = t.squareSize, y = t.squareHeight, c = (0, l.useState)(!1), a = h(c, 2), d = a[0], g = a[1], P = (0, l.useRef)(null);
    (0, k.default)(P, p, u, y);
    var x = function(L) {
      var K, Y = P == null || (K = P.current) === null || K === void 0 ? void 0 : K.getContext("2d", {
        willReadFrequently: !0
      });
      i(L, Y);
    }, M = function() {
      g(!1);
    }, B = function(L) {
      d && x(L);
    }, N = function(L) {
      d || x(L);
    }, V = function() {
      g(!0);
    }, T = function(L) {
      g(!0), x(L);
    };
    return (0, l.useEffect)(function() {
      var _ = function() {
        M();
      };
      return window.addEventListener("mouseup", _), function() {
        window.removeEventListener("mouseup", _);
      };
    }, []), /* @__PURE__ */ l.default.createElement("div", {
      style: I.psRl
    }, /* @__PURE__ */ l.default.createElement("div", {
      style: b(b({}, I.psRl), I.cCross),
      onMouseDown: T,
      onMouseMove: function(L) {
        return B(L);
      },
      onMouseUp: M
    }, /* @__PURE__ */ l.default.createElement("div", {
      style: b({
        left: e,
        top: n
      }, I.handle),
      onMouseDown: V
    }), /* @__PURE__ */ l.default.createElement("div", {
      style: b(b({}, I.canvasWrapper), {}, {
        height: y
      }),
      onClick: function(L) {
        return N(L);
      }
    }, /* @__PURE__ */ l.default.createElement("canvas", {
      ref: P,
      width: "".concat(u, "px"),
      height: "".concat(y, "px"),
      id: "paintSquare"
    }))));
  }, m = f;
  s.default = m;
})(Pt);
var _t = {};
(function(s) {
  function o(f) {
    "@babel/helpers - typeof";
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
      return typeof m;
    } : function(m) {
      return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
    }, o(f);
  }
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = void 0;
  var l = R(ve), k = Pe, q = X;
  function I(f) {
    if (typeof WeakMap != "function")
      return null;
    var m = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
    return (I = function(e) {
      return e ? r : m;
    })(f);
  }
  function R(f, m) {
    if (!m && f && f.__esModule)
      return f;
    if (f === null || o(f) !== "object" && typeof f != "function")
      return { default: f };
    var r = I(m);
    if (r && r.has(f))
      return r.get(f);
    var t = {}, e = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var n in f)
      if (n !== "default" && Object.prototype.hasOwnProperty.call(f, n)) {
        var i = e ? Object.getOwnPropertyDescriptor(f, n) : null;
        i && (i.get || i.set) ? Object.defineProperty(t, n, i) : t[n] = f[n];
      }
    return t.default = f, r && r.set(f, t), t;
  }
  function E(f, m) {
    var r = Object.keys(f);
    if (Object.getOwnPropertySymbols) {
      var t = Object.getOwnPropertySymbols(f);
      m && (t = t.filter(function(e) {
        return Object.getOwnPropertyDescriptor(f, e).enumerable;
      })), r.push.apply(r, t);
    }
    return r;
  }
  function H(f) {
    for (var m = 1; m < arguments.length; m++) {
      var r = arguments[m] != null ? arguments[m] : {};
      m % 2 ? E(Object(r), !0).forEach(function(t) {
        C(f, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(r)) : E(Object(r)).forEach(function(t) {
        Object.defineProperty(f, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return f;
  }
  function C(f, m, r) {
    return m = b(m), m in f ? Object.defineProperty(f, m, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : f[m] = r, f;
  }
  function b(f) {
    var m = A(f, "string");
    return o(m) === "symbol" ? m : String(m);
  }
  function A(f, m) {
    if (o(f) !== "object" || f === null)
      return f;
    var r = f[Symbol.toPrimitive];
    if (r !== void 0) {
      var t = r.call(f, m || "default");
      if (o(t) !== "object")
        return t;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (m === "string" ? String : Number)(f);
  }
  function O(f, m) {
    return W(f) || S(f, m) || h(f, m) || w();
  }
  function w() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function h(f, m) {
    if (f) {
      if (typeof f == "string")
        return v(f, m);
      var r = Object.prototype.toString.call(f).slice(8, -1);
      if (r === "Object" && f.constructor && (r = f.constructor.name), r === "Map" || r === "Set")
        return Array.from(f);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
        return v(f, m);
    }
  }
  function v(f, m) {
    (m == null || m > f.length) && (m = f.length);
    for (var r = 0, t = new Array(m); r < m; r++)
      t[r] = f[r];
    return t;
  }
  function S(f, m) {
    var r = f == null ? null : typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
    if (r != null) {
      var t, e, n, i, p = [], u = !0, y = !1;
      try {
        if (n = (r = r.call(f)).next, m === 0) {
          if (Object(r) !== r)
            return;
          u = !1;
        } else
          for (; !(u = (t = n.call(r)).done) && (p.push(t.value), p.length !== m); u = !0)
            ;
      } catch (c) {
        y = !0, e = c;
      } finally {
        try {
          if (!u && r.return != null && (i = r.return(), Object(i) !== i))
            return;
        } finally {
          if (y)
            throw e;
        }
      }
      return p;
    }
  }
  function W(f) {
    if (Array.isArray(f))
      return f;
  }
  var z = function() {
    var m = (0, k.usePicker)(), r = m.handleOpacity, t = m.opacity, e = m.tinyColor, n = m.squareSize, i = (0, l.useState)(!1), p = O(i, 2), u = p[0], y = p[1], c = e.toRgb(), a = c.r, d = c.g, g = c.b, P = "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(".concat(a, ",").concat(d, ",").concat(g, ",.5) 100%)"), x = function() {
      y(!1);
    }, M = function() {
      y(!0);
    }, B = function(_) {
      u && r(_);
    }, N = function(_) {
      u || r(_);
    }, V = n - 18;
    return (0, l.useEffect)(function() {
      var T = function() {
        x();
      };
      return window.addEventListener("mouseup", T), function() {
        window.removeEventListener("mouseup", T);
      };
    }, []), /* @__PURE__ */ l.default.createElement("div", {
      onMouseDown: M,
      onMouseMove: function(_) {
        return B(_);
      },
      style: H(H(H(H({}, q.cResize), q.psRl), {}, {
        height: 14
      }, q.borderBox), {}, {
        marginTop: 17,
        marginBottom: 4
      })
    }, /* @__PURE__ */ l.default.createElement("div", {
      style: H(H({}, q.checkered), {}, {
        width: "100%",
        height: 14
      })
    }), /* @__PURE__ */ l.default.createElement("div", {
      style: H({
        left: V * t,
        top: -2
      }, q.handle)
    }), /* @__PURE__ */ l.default.createElement("div", {
      style: H({
        background: P
      }, q.opacityOverlay),
      onClick: function(_) {
        return N(_);
      }
    }));
  }, j = z;
  s.default = j;
})(_t);
var Et = {};
(function(s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = void 0;
  var o = k(ve), l = Pe;
  function k(E) {
    return E && E.__esModule ? E : { default: E };
  }
  var q = function(H) {
    var C = H.presets, b = C === void 0 ? [] : C, A = (0, l.usePicker)(), O = A.value, w = A.onChange, h = A.handleChange, v = A.squareSize, S = function() {
      return (b == null ? void 0 : b.length) > 0 ? b == null ? void 0 : b.slice(0, 18) : R;
    }, W = function(j) {
      j != null && j.includes("gradient") ? w(j) : h(j);
    };
    return /* @__PURE__ */ o.default.createElement("div", {
      style: {
        display: "flex",
        marginTop: 14,
        justifyContent: "space-between"
      }
    }, /* @__PURE__ */ o.default.createElement("div", {
      style: {
        width: 50,
        height: 50,
        background: O,
        borderRadius: 6,
        flexShrink: 0
      }
    }), /* @__PURE__ */ o.default.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "wrap",
        width: v - 66,
        justifyContent: "space-between"
      }
    }, S().map(function(z, j) {
      return /* @__PURE__ */ o.default.createElement("div", {
        key: j,
        style: {
          height: 23,
          width: "10.2%",
          borderRadius: 4,
          background: z,
          marginBottom: 2,
          border: z === "rgba(255,255,255, 1)" ? "1px solid #96959c" : ""
        },
        onClick: function() {
          return W(z);
        }
      });
    })));
  }, I = q;
  s.default = I;
  var R = ["rgba(0,0,0,1)", "rgba(128,128,128, 1)", "rgba(192,192,192, 1)", "rgba(255,255,255, 1)", "rgba(0,0,128,1)", "rgba(0,0,255,1)", "rgba(0,255,255, 1)", "rgba(0,128,0,1)", "rgba(128,128,0, 1)", "rgba(0,128,128,1)", "rgba(0,255,0, 1)", "rgba(128,0,0, 1)", "rgba(128,0,128, 1)", "rgba(175, 51, 242, 1)", "rgba(255,0,255, 1)", "rgba(255,0,0, 1)", "rgba(240, 103, 46, 1)", "rgba(255,255,0, 1)"];
})(Et);
var Ye = {}, tt = {};
(function(s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = s.StopIcon = s.SlidersIcon = s.RadialIcon = s.PaletteIcon = s.LinearIcon = s.InputsIcon = s.DegreesIcon = void 0;
  var o = l(ve);
  function l(O) {
    return O && O.__esModule ? O : { default: O };
  }
  var k = function() {
    var w = {
      fill: "none",
      stroke: "rgb(50, 49, 54)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    };
    return /* @__PURE__ */ o.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 15
      }
    }, /* @__PURE__ */ o.default.createElement("polyline", {
      style: w,
      points: "17.96 4.31 2.04 4.3 3.75 4.3 4.81 17.29 5.16 17.96 5.74 18.47 6.59 18.62 13.64 18.62 14.52 18.32 15.07 17.68 15.29 17.12 16.28 4.3 12.87 4.3 12.87 2.38 12.48 1.75 11.83 1.46 8.4 1.46 7.64 1.68 7.26 2.21 7.16 2.52 7.17 4.23"
    }));
  }, q = k;
  s.default = q;
  var I = function(w) {
    var h = w.color, v = h || "#323136", S = {
      fill: "none",
      stroke: v,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    };
    return /* @__PURE__ */ o.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 14
      }
    }, /* @__PURE__ */ o.default.createElement("polyline", {
      style: S,
      points: "0.9 12.73 0.9 19.1 7.27 19.1 0.9 19.1 19.1 0.9 12.73 0.9 19.1 0.9 19.1 7.27"
    }));
  };
  s.LinearIcon = I;
  var R = function(w) {
    var h = w.color, v = h || "#323136", S = {
      fill: "none",
      stroke: v,
      strokeMiterlimit: 10,
      strokeWidth: "1.8px"
    };
    return /* @__PURE__ */ o.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 15
      }
    }, /* @__PURE__ */ o.default.createElement("circle", {
      style: S,
      cx: "10",
      cy: "10",
      r: "9"
    }), /* @__PURE__ */ o.default.createElement("circle", {
      style: S,
      cx: "10",
      cy: "10",
      r: "5"
    }));
  };
  s.RadialIcon = R;
  var E = function(w) {
    var h = w.color, v = h || "#323136", S = {
      fill: "none",
      stroke: v,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px",
      fillRule: "evenodd"
    }, W = {
      fill: v,
      stroke: v,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    };
    return /* @__PURE__ */ o.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 17
      }
    }, /* @__PURE__ */ o.default.createElement("polyline", {
      style: S,
      points: "3.74 2.75 3.74 12.69 0.9 12.71 6.59 12.71"
    }), /* @__PURE__ */ o.default.createElement("line", {
      style: W,
      x1: "3.74",
      y1: "17.26",
      x2: "3.74",
      y2: "15.21"
    }), /* @__PURE__ */ o.default.createElement("polyline", {
      style: S,
      points: "10.1 17.25 10.1 7.31 12.95 7.29 7.26 7.29"
    }), /* @__PURE__ */ o.default.createElement("line", {
      style: W,
      x1: "10.1",
      y1: "2.74",
      x2: "10.1",
      y2: "4.79"
    }), /* @__PURE__ */ o.default.createElement("polyline", {
      style: S,
      points: "16.26 2.75 16.26 12.69 13.41 12.71 19.1 12.71"
    }), /* @__PURE__ */ o.default.createElement("line", {
      style: W,
      x1: "16.26",
      y1: "17.26",
      x2: "16.26",
      y2: "15.21"
    }));
  };
  s.SlidersIcon = E;
  var H = function(w) {
    var h = w.color, v = h || "#323136", S = {
      fill: "none",
      stroke: v,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8px"
    };
    return /* @__PURE__ */ o.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 17
      }
    }, /* @__PURE__ */ o.default.createElement("path", {
      style: S,
      d: "M6.35,2.72a4.85,4.85,0,0,1,1.86.16,7.94,7.94,0,0,1,.88.43,3.66,3.66,0,0,0,.85.49c.25,0,.58-.27.81-.39A8.25,8.25,0,0,1,11.7,3a4,4,0,0,1,1.79-.23,3.21,3.21,0,0,0-1.34.09,6.39,6.39,0,0,0-1.47.63c-.45.25-.7.3-.7.86s0,1.18,0,1.78c0,1.3,0,2.61,0,3.92h0v5.63a2.46,2.46,0,0,1,0,.47c-.07.28-.43.42-.7.57a5.29,5.29,0,0,1-2.94.61A9.3,9.3,0,0,0,8,17.15l1.09-.37.89-.52c.06,0,.48.21.56.25.32.14.64.27,1,.38a8.54,8.54,0,0,0,2.12.4"
    }), /* @__PURE__ */ o.default.createElement("path", {
      style: S,
      d: "M7.57,5.73C6,5.7,4.5,5.65,3,5.77a2.28,2.28,0,0,0-1.76.74A2.3,2.3,0,0,0,.94,7.83l0,3.82A4.73,4.73,0,0,0,1,12.9a1.64,1.64,0,0,0,.68,1,2.44,2.44,0,0,0,1,.27,25,25,0,0,0,4.74.09"
    }), /* @__PURE__ */ o.default.createElement("path", {
      style: S,
      d: "M12.43,14.32a44.12,44.12,0,0,0,4.6,0,2.24,2.24,0,0,0,1.76-.74,2.29,2.29,0,0,0,.27-1.32l0-3.81A4.81,4.81,0,0,0,19,7.15a1.62,1.62,0,0,0-.68-1,2.31,2.31,0,0,0-1-.28,26.8,26.8,0,0,0-4.74-.09"
    }));
  };
  s.InputsIcon = H;
  var C = function(w) {
    var h = w.color, v = h || "#323136", S = {
      fill: v
    }, W = {
      fill: v,
      stroke: v,
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    };
    return /* @__PURE__ */ o.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 17
      }
    }, /* @__PURE__ */ o.default.createElement("circle", {
      style: S,
      cx: "9.36",
      cy: "5.07",
      r: "1.71"
    }), /* @__PURE__ */ o.default.createElement("circle", {
      style: S,
      cx: "13.93",
      cy: "6.91",
      r: "1.71"
    }), /* @__PURE__ */ o.default.createElement("circle", {
      style: S,
      cx: "5.8",
      cy: "7.55",
      r: "1.71"
    }), /* @__PURE__ */ o.default.createElement("circle", {
      style: S,
      cx: "5.45",
      cy: "12.04",
      r: "1.71"
    }), /* @__PURE__ */ o.default.createElement("path", {
      style: W,
      d: "M19.1,10c0,3.58-2.12,2.94-4.06,2.35-1.15-.34-2.24-.67-2.77-.08-.68.78-.54,2.07-.39,3.33.2,1.79.39,3.5-1.88,3.5A9.1,9.1,0,1,1,19.1,10ZM10,18c.7,0,.74-.19.75-.2a2.67,2.67,0,0,0,.07-1.27c0-.19,0-.42-.06-.67-.06-.53-.13-1.15-.14-1.67a3.82,3.82,0,0,1,.8-2.63,2.14,2.14,0,0,1,1.45-.7,4.36,4.36,0,0,1,1.32.12c.39.08.8.21,1.16.32h0c.39.12.74.23,1.08.3.74.17,1,.1,1.13,0S18,11.32,18,10a8,8,0,1,0-8,8Z"
    }));
  };
  s.PaletteIcon = C;
  var b = function(w) {
    var h = w.color, v = h || "#323136", S = {
      fill: "none",
      stroke: v,
      strokeMiterlimit: 10,
      strokeWidth: "1.8px",
      strokeLinecap: "round"
    };
    return /* @__PURE__ */ o.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 15
      }
    }, /* @__PURE__ */ o.default.createElement("polyline", {
      style: S,
      points: "13.86 2.01 1.7 16.99 18.77 16.99"
    }), /* @__PURE__ */ o.default.createElement("polyline", {
      style: S,
      points: "10.96 16.38 10.96 16.38 10.74 15.7 10.44 14.97 10.06 14.21 9.72 13.63 9.21 12.89 8.85 12.44 8.41 11.95 7.91 11.45 7.51 11.1"
    }));
  };
  s.DegreesIcon = b;
  var A = function() {
    return /* @__PURE__ */ o.default.createElement("svg", {
      id: "Layer_1",
      "data-name": "Layer 1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      style: {
        width: 20,
        marginRight: 1
      }
    }, /* @__PURE__ */ o.default.createElement("path", {
      d: "M2.39,8c-.63,0-1,.21-1,.63A.49.49,0,0,0,1.67,9a6.48,6.48,0,0,0,1.11.43A3,3,0,0,1,4,10.09a1.47,1.47,0,0,1,.35,1.09,1.75,1.75,0,0,1-.57,1.42,2.21,2.21,0,0,1-1.48.48,8.32,8.32,0,0,1-1.68-.21l-.31-.06.12-.94a13.7,13.7,0,0,0,1.8.16c.61,0,.92-.26.92-.77a.52.52,0,0,0-.21-.44,3.13,3.13,0,0,0-.85-.34A3.32,3.32,0,0,1,.66,9.79a1.43,1.43,0,0,1-.42-1.1A1.6,1.6,0,0,1,.78,7.36a2.32,2.32,0,0,1,1.49-.44,10.46,10.46,0,0,1,1.64.17l.32.07-.1.95C3.31,8,2.73,8,2.39,8Z"
    }), /* @__PURE__ */ o.default.createElement("path", {
      d: "M4.79,8.09V7H9.16V8.09H7.59V13H6.38V8.09Z"
    }), /* @__PURE__ */ o.default.createElement("path", {
      d: "M14,12.34a2.25,2.25,0,0,1-1.91.74,2.24,2.24,0,0,1-1.91-.74A3.85,3.85,0,0,1,9.61,10a4,4,0,0,1,.56-2.34,2.2,2.2,0,0,1,1.91-.77A2.21,2.21,0,0,1,14,7.69,4,4,0,0,1,14.55,10,3.85,3.85,0,0,1,14,12.34Zm-2.88-.77a1,1,0,0,0,1,.46,1,1,0,0,0,1-.46A3.25,3.25,0,0,0,13.3,10,3.45,3.45,0,0,0,13,8.46a1,1,0,0,0-1-.49,1,1,0,0,0-1,.49A3.43,3.43,0,0,0,10.85,10,3.38,3.38,0,0,0,11.11,11.57Z"
    }), /* @__PURE__ */ o.default.createElement("path", {
      d: "M17.77,11.24h-1V13H15.58V7h2.19a1.85,1.85,0,0,1,2.11,2.07,2.21,2.21,0,0,1-.54,1.6A2.07,2.07,0,0,1,17.77,11.24Zm-1-1h1c.6,0,.9-.37.9-1.12a1.18,1.18,0,0,0-.22-.79.88.88,0,0,0-.68-.24h-1Z"
    }));
  };
  s.StopIcon = A;
})(tt);
var Xe = {}, kt = {};
(function(s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = void 0;
  var o = ve, l = er;
  function k(A, O) {
    return H(A) || E(A, O) || I(A, O) || q();
  }
  function q() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function I(A, O) {
    if (A) {
      if (typeof A == "string")
        return R(A, O);
      var w = Object.prototype.toString.call(A).slice(8, -1);
      if (w === "Object" && A.constructor && (w = A.constructor.name), w === "Map" || w === "Set")
        return Array.from(A);
      if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w))
        return R(A, O);
    }
  }
  function R(A, O) {
    (O == null || O > A.length) && (O = A.length);
    for (var w = 0, h = new Array(O); w < O; w++)
      h[w] = A[w];
    return h;
  }
  function E(A, O) {
    var w = A == null ? null : typeof Symbol < "u" && A[Symbol.iterator] || A["@@iterator"];
    if (w != null) {
      var h, v, S, W, z = [], j = !0, f = !1;
      try {
        if (S = (w = w.call(A)).next, O === 0) {
          if (Object(w) !== w)
            return;
          j = !1;
        } else
          for (; !(j = (h = S.call(w)).done) && (z.push(h.value), z.length !== O); j = !0)
            ;
      } catch (m) {
        f = !0, v = m;
      } finally {
        try {
          if (!j && w.return != null && (W = w.return(), Object(W) !== W))
            return;
        } finally {
          if (f)
            throw v;
        }
      }
      return z;
    }
  }
  function H(A) {
    if (Array.isArray(A))
      return A;
  }
  var C = function(O) {
    var w = O.children, h = "id" + Math.random().toString(16).slice(2), v = (0, o.useRef)(document.getElementById(h) || document.createElement("div")), S = (0, o.useState)(!v.current.parentElement), W = k(S, 1), z = W[0];
    return (0, o.useEffect)(function() {
      var j = v.current;
      return z && (v.current.id = h, document.body.appendChild(v.current)), function() {
        z && j.parentElement && j.parentElement.removeChild(j);
      };
    }, [h]), /* @__PURE__ */ (0, l.createPortal)(w, v.current);
  }, b = /* @__PURE__ */ (0, o.memo)(C);
  s.default = b;
})(kt);
var pt;
function Rr() {
  return pt || (pt = 1, function(s) {
    function o(e) {
      "@babel/helpers - typeof";
      return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
      } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, o(e);
    }
    Object.defineProperty(s, "__esModule", {
      value: !0
    }), s.default = void 0;
    var l = H(ve), k = R(kt), q = R(rr), I = rt();
    function R(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function E(e) {
      if (typeof WeakMap != "function")
        return null;
      var n = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
      return (E = function(u) {
        return u ? i : n;
      })(e);
    }
    function H(e, n) {
      if (!n && e && e.__esModule)
        return e;
      if (e === null || o(e) !== "object" && typeof e != "function")
        return { default: e };
      var i = E(n);
      if (i && i.has(e))
        return i.get(e);
      var p = {}, u = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var y in e)
        if (y !== "default" && Object.prototype.hasOwnProperty.call(e, y)) {
          var c = u ? Object.getOwnPropertyDescriptor(e, y) : null;
          c && (c.get || c.set) ? Object.defineProperty(p, y, c) : p[y] = e[y];
        }
      return p.default = e, i && i.set(e, p), p;
    }
    function C(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(e);
        n && (p = p.filter(function(u) {
          return Object.getOwnPropertyDescriptor(e, u).enumerable;
        })), i.push.apply(i, p);
      }
      return i;
    }
    function b(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? C(Object(i), !0).forEach(function(p) {
          A(e, p, i[p]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : C(Object(i)).forEach(function(p) {
          Object.defineProperty(e, p, Object.getOwnPropertyDescriptor(i, p));
        });
      }
      return e;
    }
    function A(e, n, i) {
      return n = O(n), n in e ? Object.defineProperty(e, n, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = i, e;
    }
    function O(e) {
      var n = w(e, "string");
      return o(n) === "symbol" ? n : String(n);
    }
    function w(e, n) {
      if (o(e) !== "object" || e === null)
        return e;
      var i = e[Symbol.toPrimitive];
      if (i !== void 0) {
        var p = i.call(e, n || "default");
        if (o(p) !== "object")
          return p;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (n === "string" ? String : Number)(e);
    }
    function h(e, n) {
      return j(e) || z(e, n) || S(e, n) || v();
    }
    function v() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function S(e, n) {
      if (e) {
        if (typeof e == "string")
          return W(e, n);
        var i = Object.prototype.toString.call(e).slice(8, -1);
        if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set")
          return Array.from(e);
        if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
          return W(e, n);
      }
    }
    function W(e, n) {
      (n == null || n > e.length) && (n = e.length);
      for (var i = 0, p = new Array(n); i < n; i++)
        p[i] = e[i];
      return p;
    }
    function z(e, n) {
      var i = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
      if (i != null) {
        var p, u, y, c, a = [], d = !0, g = !1;
        try {
          if (y = (i = i.call(e)).next, n === 0) {
            if (Object(i) !== i)
              return;
            d = !1;
          } else
            for (; !(d = (p = y.call(i)).done) && (a.push(p.value), a.length !== n); d = !0)
              ;
        } catch (P) {
          g = !0, u = P;
        } finally {
          try {
            if (!d && i.return != null && (c = i.return(), Object(c) !== c))
              return;
          } finally {
            if (g)
              throw u;
          }
        }
        return a;
      }
    }
    function j(e) {
      if (Array.isArray(e))
        return e;
    }
    var f = Re, m = function(n) {
      var i = n.color, p = i || "#323136", u = {
        fill: "none",
        stroke: p,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.4px"
      }, y = {
        fill: p,
        stroke: p,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.4px"
      };
      return /* @__PURE__ */ l.default.createElement("svg", {
        id: "Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        style: {
          width: 16
        }
      }, /* @__PURE__ */ l.default.createElement("path", {
        style: u,
        d: "M15.6,7h0L7.78,14.86c-.37.37-1.61.38-2,.75s-.5,1.53-.76,2a3.53,3.53,0,0,1-.52.52,1.6,1.6,0,0,1-2.27-.06l-.32-.32a1.61,1.61,0,0,1-.06-2.27A3.25,3.25,0,0,1,2.4,15c.47-.26,1.65-.35,2-.73s.34-1.64.71-2c1.68-1.73,5.61-5.65,7.91-7.93h0l1.14,1.38L15.6,7Z"
      }), /* @__PURE__ */ l.default.createElement("polygon", {
        style: y,
        points: "15.7 8.87 11.13 4.29 12.69 2.73 17.25 7.31 15.7 8.87"
      }), /* @__PURE__ */ l.default.createElement("path", {
        style: y,
        d: "M18.18,3.71,16.36,5.53a1.33,1.33,0,0,1-1.88,0h0a1.34,1.34,0,0,1,0-1.89l1.81-1.82a1.34,1.34,0,0,1,1.89,0h0A1.34,1.34,0,0,1,18.18,3.71Z"
      }));
    }, r = function(n) {
      var i = n.onSelect, p = n.buttonStyle, u = (0, l.useState)(""), y = h(u, 2), c = y[0], a = y[1], d = (0, l.useState)(!1), g = h(d, 2), P = g[0], x = g[1], M = function() {
        var T = document.getElementById("root");
        x(!0), (0, q.default)(T).then(function(_) {
          var L = document.createElement("canvas"), K = L.getContext("2d", {
            willReadFrequently: !0
          });
          L.width = T.offsetWidth * 2, L.height = T.offsetHeight * 2, K.drawImage(_, 0, 0), a(K);
        });
      }, B = function(T) {
        T.stopPropagation();
        var _ = T.pageX, L = T.pageY, K = _ * 2, Y = L * 2, J = h(c.getImageData(K, Y, 1, 1).data, 3), G = J[0], F = J[1], le = J[2];
        i("rgba(".concat(G, ", ").concat(F, ", ").concat(le, ", 1)")), x(!1);
      }, N = function() {
        if (!window.EyeDropper)
          M();
        else {
          var T = new window.EyeDropper(), _ = new window.AbortController();
          T.open({
            signal: _.signal
          }).then(function(L) {
            var K = f(L.sRGBHex), Y = K.toRgb(), J = Y.r, G = Y.g, F = Y.b;
            i("rgba(".concat(J, ", ").concat(G, ", ").concat(F, ", 1)"));
          }).catch(function(L) {
            console.log(L);
          });
        }
      };
      return /* @__PURE__ */ l.default.createElement("div", null, /* @__PURE__ */ l.default.createElement("div", {
        style: b(b({}, p), (0, I.controlBtnStyles)(P)),
        onClick: N
      }, /* @__PURE__ */ l.default.createElement(m, {
        color: P ? "rgb(86, 140, 245)" : ""
      })), P && /* @__PURE__ */ l.default.createElement(k.default, {
        id: "eyeDropCover"
      }, /* @__PURE__ */ l.default.createElement("div", {
        style: {
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: 1e8,
          width: window.innerWidth,
          height: window.innerHeight,
          cursor: "copy"
        },
        onClick: function(T) {
          return B(T);
        }
      })));
    }, t = r;
    s.default = t;
  }(Xe)), Xe;
}
var At = {};
(function(s) {
  function o(e) {
    "@babel/helpers - typeof";
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, o(e);
  }
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = void 0;
  var l = H(ve), k = Pe, q = je(), I = et, R = X;
  function E(e) {
    if (typeof WeakMap != "function")
      return null;
    var n = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
    return (E = function(u) {
      return u ? i : n;
    })(e);
  }
  function H(e, n) {
    if (!n && e && e.__esModule)
      return e;
    if (e === null || o(e) !== "object" && typeof e != "function")
      return { default: e };
    var i = E(n);
    if (i && i.has(e))
      return i.get(e);
    var p = {}, u = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var y in e)
      if (y !== "default" && Object.prototype.hasOwnProperty.call(e, y)) {
        var c = u ? Object.getOwnPropertyDescriptor(e, y) : null;
        c && (c.get || c.set) ? Object.defineProperty(p, y, c) : p[y] = e[y];
      }
    return p.default = e, i && i.set(e, p), p;
  }
  function C(e, n) {
    var i = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var p = Object.getOwnPropertySymbols(e);
      n && (p = p.filter(function(u) {
        return Object.getOwnPropertyDescriptor(e, u).enumerable;
      })), i.push.apply(i, p);
    }
    return i;
  }
  function b(e) {
    for (var n = 1; n < arguments.length; n++) {
      var i = arguments[n] != null ? arguments[n] : {};
      n % 2 ? C(Object(i), !0).forEach(function(p) {
        A(e, p, i[p]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : C(Object(i)).forEach(function(p) {
        Object.defineProperty(e, p, Object.getOwnPropertyDescriptor(i, p));
      });
    }
    return e;
  }
  function A(e, n, i) {
    return n = O(n), n in e ? Object.defineProperty(e, n, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = i, e;
  }
  function O(e) {
    var n = w(e, "string");
    return o(n) === "symbol" ? n : String(n);
  }
  function w(e, n) {
    if (o(e) !== "object" || e === null)
      return e;
    var i = e[Symbol.toPrimitive];
    if (i !== void 0) {
      var p = i.call(e, n || "default");
      if (o(p) !== "object")
        return p;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (n === "string" ? String : Number)(e);
  }
  function h(e, n) {
    return j(e) || z(e, n) || S(e, n) || v();
  }
  function v() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function S(e, n) {
    if (e) {
      if (typeof e == "string")
        return W(e, n);
      var i = Object.prototype.toString.call(e).slice(8, -1);
      if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set")
        return Array.from(e);
      if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
        return W(e, n);
    }
  }
  function W(e, n) {
    (n == null || n > e.length) && (n = e.length);
    for (var i = 0, p = new Array(n); i < n; i++)
      p[i] = e[i];
    return p;
  }
  function z(e, n) {
    var i = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (i != null) {
      var p, u, y, c, a = [], d = !0, g = !1;
      try {
        if (y = (i = i.call(e)).next, n === 0) {
          if (Object(i) !== i)
            return;
          d = !1;
        } else
          for (; !(d = (p = y.call(i)).done) && (a.push(p.value), a.length !== n); d = !0)
            ;
      } catch (P) {
        g = !0, u = P;
      } finally {
        try {
          if (!d && i.return != null && (c = i.return(), Object(c) !== c))
            return;
        } finally {
          if (g)
            throw u;
        }
      }
      return a;
    }
  }
  function j(e) {
    if (Array.isArray(e))
      return e;
  }
  var f = Re, m = function(n) {
    var i = n.openAdvanced, p = (0, k.usePicker)(), u = p.tinyColor, y = p.hue, c = p.l, a = p.handleChange, d = p.s, g = p.opacity, P = p.squareSize, x = u.toHsv(), M = x.v, B = x.s, N = (0, l.useRef)(null), V = (0, l.useRef)(null), T = (0, l.useRef)(null);
    (0, I.usePaintSat)(N, y, c * 100, P), (0, I.usePaintLight)(V, y, d * 100, P), (0, I.usePaintBright)(T, y, d * 100, P);
    var _ = function(J) {
      var G = f({
        h: y,
        s: J / 100,
        l: c
      }).toRgb(), F = G.r, le = G.g, fe = G.b;
      a("rgba(".concat(F, ",").concat(le, ",").concat(fe, ",").concat(g, ")"));
    }, L = function(J) {
      var G = f({
        h: y,
        s: d,
        l: J / 100
      }).toRgb(), F = G.r, le = G.g, fe = G.b;
      a("rgba(".concat(F, ",").concat(le, ",").concat(fe, ",").concat(g, ")"));
    }, K = function(J) {
      var G = f({
        h: y,
        s: B * 100,
        v: J
      }).toRgb(), F = G.r, le = G.g, fe = G.b;
      a("rgba(".concat(F, ",").concat(le, ",").concat(fe, ",").concat(g, ")"));
    };
    return /* @__PURE__ */ l.default.createElement("div", {
      style: {
        height: i ? 98 : 0,
        width: "100%",
        transition: "all 120ms linear"
      }
    }, /* @__PURE__ */ l.default.createElement("div", {
      style: {
        paddingTop: 11,
        display: i ? "" : "none"
      }
    }, /* @__PURE__ */ l.default.createElement(t, {
      value: d,
      reffy: N,
      callback: _,
      openAdvanced: i,
      label: "Saturation"
    }), /* @__PURE__ */ l.default.createElement(t, {
      value: c,
      reffy: V,
      label: "Lightness",
      callback: L,
      openAdvanced: i
    }), /* @__PURE__ */ l.default.createElement(t, {
      value: M,
      reffy: T,
      label: "Brightness",
      callback: K,
      openAdvanced: i
    })));
  }, r = m;
  s.default = r;
  var t = function(n) {
    var i = n.value, p = n.callback, u = n.reffy, y = n.openAdvanced, c = n.label, a = (0, k.usePicker)(), d = a.squareSize, g = (0, l.useState)(!1), P = h(g, 2), x = P[0], M = P[1], B = (0, l.useState)(2), N = h(B, 2), V = N[0], T = N[1], _ = i * (d - 18);
    (0, l.useEffect)(function() {
      var G;
      T((u == null || (G = u.current) === null || G === void 0 ? void 0 : G.offsetTop) - 2);
    }, [y, u]);
    var L = function() {
      M(!1);
    }, K = function(F) {
      x && p((0, q.getHandleValue)(F));
    }, Y = function(F) {
      x || p((0, q.getHandleValue)(F));
    }, J = function() {
      M(!0);
    };
    return (0, l.useEffect)(function() {
      var G = function() {
        L();
      };
      return window.addEventListener("mouseup", G), function() {
        window.removeEventListener("mouseup", G);
      };
    }, []), /* @__PURE__ */ l.default.createElement("div", {
      style: b(b({}, R.borderBox), {}, {
        width: "100%",
        padding: "3px 0px 3px 0px"
      })
    }, /* @__PURE__ */ l.default.createElement("div", {
      className: "c-resize ps-rl",
      onMouseMove: function(F) {
        return K(F);
      },
      style: b(b({}, R.cResize), R.psRl)
    }, /* @__PURE__ */ l.default.createElement("div", {
      style: b(b({}, R.handle), {}, {
        left: _,
        top: V
      }),
      onMouseDown: J
    }), /* @__PURE__ */ l.default.createElement("div", {
      style: {
        textAlign: "center",
        color: "#fff",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1,
        position: "absolute",
        left: "50%",
        transform: "translate(-50%, 0%)",
        top: V + 2,
        zIndex: 10,
        textShadow: "1px 1px 1px rgba(0,0,0,.6)"
      },
      onMouseMove: function(F) {
        return K(F);
      },
      onClick: function(F) {
        return Y(F);
      }
    }, c), /* @__PURE__ */ l.default.createElement("canvas", {
      ref: u,
      width: "".concat(d, "px"),
      height: "14px",
      style: {
        position: "relative",
        borderRadius: 14
      },
      onClick: function(F) {
        return Y(F);
      }
    })));
  };
})(At);
var It = {};
(function(s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = void 0;
  var o = q(ve), l = Pe, k = X;
  function q(w) {
    return w && w.__esModule ? w : { default: w };
  }
  function I(w) {
    "@babel/helpers - typeof";
    return I = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
      return typeof h;
    } : function(h) {
      return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
    }, I(w);
  }
  function R(w, h) {
    var v = Object.keys(w);
    if (Object.getOwnPropertySymbols) {
      var S = Object.getOwnPropertySymbols(w);
      h && (S = S.filter(function(W) {
        return Object.getOwnPropertyDescriptor(w, W).enumerable;
      })), v.push.apply(v, S);
    }
    return v;
  }
  function E(w) {
    for (var h = 1; h < arguments.length; h++) {
      var v = arguments[h] != null ? arguments[h] : {};
      h % 2 ? R(Object(v), !0).forEach(function(S) {
        H(w, S, v[S]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(w, Object.getOwnPropertyDescriptors(v)) : R(Object(v)).forEach(function(S) {
        Object.defineProperty(w, S, Object.getOwnPropertyDescriptor(v, S));
      });
    }
    return w;
  }
  function H(w, h, v) {
    return h = C(h), h in w ? Object.defineProperty(w, h, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : w[h] = v, w;
  }
  function C(w) {
    var h = b(w, "string");
    return I(h) === "symbol" ? h : String(h);
  }
  function b(w, h) {
    if (I(w) !== "object" || w === null)
      return w;
    var v = w[Symbol.toPrimitive];
    if (v !== void 0) {
      var S = v.call(w, h || "default");
      if (I(S) !== "object")
        return S;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (h === "string" ? String : Number)(w);
  }
  var A = function(h) {
    var v = h.openComparibles, S = (0, l.usePicker)(), W = S.tinyColor, z = S.handleChange, j = W.analogous(), f = W.monochromatic(), m = W.triad(), r = W.tetrad(), t = function(n) {
      var i = n.toRgb(), p = i.r, u = i.g, y = i.b, c = i.a;
      z("rgba(".concat(p, ",").concat(u, ",").concat(y, ",").concat(c, ")"));
    };
    return /* @__PURE__ */ o.default.createElement("div", {
      style: {
        height: v ? 216 : 0,
        width: "100%",
        transition: "all 120ms linear"
      }
    }, /* @__PURE__ */ o.default.createElement("div", {
      style: E({
        paddingTop: 11,
        display: v ? "" : "none"
      }, k.psRl)
    }, /* @__PURE__ */ o.default.createElement("div", {
      style: {
        textAlign: "center",
        color: "#323136",
        fontSize: 13,
        fontWeight: 600,
        position: "absolute",
        top: 6.5,
        left: 2
      }
    }, "Color Guide"), /* @__PURE__ */ o.default.createElement("div", {
      style: {
        textAlign: "center",
        color: "#323136",
        fontSize: 12,
        fontWeight: 500,
        marginTop: 3
      }
    }, "Analogous"), /* @__PURE__ */ o.default.createElement("div", {
      style: E({
        borderRadius: 5,
        overflow: "hidden"
      }, k.df)
    }, j == null ? void 0 : j.map(function(e, n) {
      return /* @__PURE__ */ o.default.createElement("div", {
        key: n,
        style: {
          width: "20%",
          height: 30,
          background: e.toHexString()
        },
        onClick: function() {
          return t(e);
        }
      });
    })), /* @__PURE__ */ o.default.createElement("div", {
      style: {
        textAlign: "center",
        color: "#323136",
        fontSize: 12,
        fontWeight: 500,
        marginTop: 3
      }
    }, "Monochromatic"), /* @__PURE__ */ o.default.createElement("div", {
      style: E(E({
        borderRadius: 5,
        overflow: "hidden"
      }, k.df), k.jfe)
    }, f == null ? void 0 : f.map(function(e, n) {
      return /* @__PURE__ */ o.default.createElement("div", {
        key: n,
        style: {
          width: "20%",
          height: 30,
          background: e.toHexString()
        },
        onClick: function() {
          return t(e);
        }
      });
    })), /* @__PURE__ */ o.default.createElement("div", {
      style: {
        textAlign: "center",
        color: "#323136",
        fontSize: 12,
        fontWeight: 500,
        marginTop: 3
      }
    }, "Triad"), /* @__PURE__ */ o.default.createElement("div", {
      style: E(E({
        borderRadius: 5,
        overflow: "hidden"
      }, k.df), k.jfe)
    }, m == null ? void 0 : m.map(function(e, n) {
      return /* @__PURE__ */ o.default.createElement("div", {
        key: n,
        style: {
          width: "calc(100% / 3)",
          height: 28,
          background: e.toHexString()
        },
        onClick: function() {
          return t(e);
        }
      });
    })), /* @__PURE__ */ o.default.createElement("div", {
      style: {
        textAlign: "center",
        color: "#323136",
        fontSize: 12,
        fontWeight: 500,
        marginTop: 3
      }
    }, "Tetrad"), /* @__PURE__ */ o.default.createElement("div", {
      style: E(E({
        borderRadius: 5,
        overflow: "hidden"
      }, k.df), k.jfe)
    }, r == null ? void 0 : r.map(function(e, n) {
      return /* @__PURE__ */ o.default.createElement("div", {
        key: n,
        style: {
          width: "25%",
          height: 28,
          background: e.toHexString()
        },
        onClick: function() {
          return t(e);
        }
      });
    }))));
  }, O = A;
  s.default = O;
})(It);
var Ze = {}, yt;
function Tr() {
  return yt || (yt = 1, function(s) {
    Object.defineProperty(s, "__esModule", {
      value: !0
    }), s.default = void 0;
    var o = C(ve), l = Pe, k = xe(), q = rt(), I = H(tt), R = X;
    function E(r) {
      if (typeof WeakMap != "function")
        return null;
      var t = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap();
      return (E = function(i) {
        return i ? e : t;
      })(r);
    }
    function H(r, t) {
      if (!t && r && r.__esModule)
        return r;
      if (r === null || b(r) !== "object" && typeof r != "function")
        return { default: r };
      var e = E(t);
      if (e && e.has(r))
        return e.get(r);
      var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var p in r)
        if (p !== "default" && Object.prototype.hasOwnProperty.call(r, p)) {
          var u = i ? Object.getOwnPropertyDescriptor(r, p) : null;
          u && (u.get || u.set) ? Object.defineProperty(n, p, u) : n[p] = r[p];
        }
      return n.default = r, e && e.set(r, n), n;
    }
    function C(r) {
      return r && r.__esModule ? r : { default: r };
    }
    function b(r) {
      "@babel/helpers - typeof";
      return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
        return typeof t;
      } : function(t) {
        return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, b(r);
    }
    function A(r, t) {
      var e = Object.keys(r);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(r);
        t && (n = n.filter(function(i) {
          return Object.getOwnPropertyDescriptor(r, i).enumerable;
        })), e.push.apply(e, n);
      }
      return e;
    }
    function O(r) {
      for (var t = 1; t < arguments.length; t++) {
        var e = arguments[t] != null ? arguments[t] : {};
        t % 2 ? A(Object(e), !0).forEach(function(n) {
          w(r, n, e[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : A(Object(e)).forEach(function(n) {
          Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(e, n));
        });
      }
      return r;
    }
    function w(r, t, e) {
      return t = h(t), t in r ? Object.defineProperty(r, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = e, r;
    }
    function h(r) {
      var t = v(r, "string");
      return b(t) === "symbol" ? t : String(t);
    }
    function v(r, t) {
      if (b(r) !== "object" || r === null)
        return r;
      var e = r[Symbol.toPrimitive];
      if (e !== void 0) {
        var n = e.call(r, t || "default");
        if (b(n) !== "object")
          return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (t === "string" ? String : Number)(r);
    }
    var S = function(t) {
      var e = t.hideGradientType, n = t.hideGradientAngle, i = t.hideGradientStop, p = (0, l.usePicker)(), u = p.gradientType;
      return /* @__PURE__ */ o.default.createElement("div", {
        style: O(O(O(O({}, R.df), R.jsb), {}, {
          marginTop: 12,
          marginBottom: -4,
          background: "#e9e9f5",
          borderRadius: 6
        }, R.borderBox), {}, {
          paddingLeft: e ? 4 : 0
        })
      }, !e && /* @__PURE__ */ o.default.createElement(z, null), /* @__PURE__ */ o.default.createElement("div", {
        style: {
          width: 53
        }
      }, !n && u === "linear-gradient" && /* @__PURE__ */ o.default.createElement(f, null)), !i && /* @__PURE__ */ o.default.createElement(j, null), /* @__PURE__ */ o.default.createElement(m, null));
    }, W = S;
    s.default = W;
    var z = function() {
      var t = (0, l.usePicker)(), e = t.gradientType, n = t.internalOnChange, i = t.value, p = e === "linear-gradient", u = e === "radial-gradient", y = function() {
        var d = i.split(/,(.+)/)[1];
        n("linear-gradient(90deg, ".concat(d));
      }, c = function() {
        var d = i.split(/,(.+)/)[1];
        n("radial-gradient(circle, ".concat(d));
      };
      return /* @__PURE__ */ o.default.createElement("div", {
        style: O(O(O(O({}, R.df), R.ac), R.controlBtnsWrap), R.borderBox)
      }, /* @__PURE__ */ o.default.createElement("div", {
        onClick: y,
        style: O(O({}, R.controlBtn), (0, q.controlBtnStyles)(p))
      }, /* @__PURE__ */ o.default.createElement(I.LinearIcon, {
        color: p ? "#568CF5" : ""
      })), /* @__PURE__ */ o.default.createElement("div", {
        onClick: c,
        style: O(O({}, R.controlBtn), (0, q.controlBtnStyles)(u))
      }, /* @__PURE__ */ o.default.createElement(I.RadialIcon, {
        color: u ? "#568CF5" : ""
      })));
    }, j = function() {
      var t = (0, l.usePicker)(), e = t.currentLeft, n = t.handleGradient, i = t.currentColor, p = function(y) {
        n(i, (0, k.formatInputValues)(y, 0, 100));
      };
      return /* @__PURE__ */ o.default.createElement("div", {
        style: O(O(O(O({}, R.df), R.ac), R.controlBtnsWrap), {}, {
          paddingLeft: 8
        })
      }, /* @__PURE__ */ o.default.createElement(I.StopIcon, null), /* @__PURE__ */ o.default.createElement("input", {
        id: "rbgcp-input",
        style: R.degreeInput,
        value: e,
        onChange: function(y) {
          return p(y.target.value || 0);
        }
      }));
    }, f = function() {
      var t = (0, l.usePicker)(), e = t.degrees, n = t.internalOnChange, i = t.value, p = function(y) {
        var c = (0, k.formatInputValues)(y.target.value, 0, 360), a = i.split(/,(.+)/)[1];
        n("linear-gradient(".concat(c || 0, "deg, ").concat(a));
      };
      return /* @__PURE__ */ o.default.createElement("div", {
        style: O(O(O(O({}, R.psRl), R.controlBtnsWrap), R.df), R.ac)
      }, /* @__PURE__ */ o.default.createElement(I.DegreesIcon, null), /* @__PURE__ */ o.default.createElement("input", {
        id: "rbgcp-input",
        style: R.degreeInput,
        value: e,
        onChange: function(y) {
          return p(y);
        }
      }), /* @__PURE__ */ o.default.createElement("div", {
        style: {
          position: "absolute",
          right: e > 99 ? 0 : e < 10 ? 7 : 3,
          top: 1,
          fontWeight: 400,
          fontSize: 13
        }
      }, "°"));
    }, m = function() {
      var t = (0, l.usePicker)(), e = t.deletePoint;
      return /* @__PURE__ */ o.default.createElement("div", {
        onClick: e,
        style: O(O(O(O(O(O({}, R.df), R.jc), R.ac), R.controlBtnsWrap), {}, {
          width: 30
        }, (0, q.controlBtnStyles)(!1)), {}, {
          marginRight: 1
        })
      }, /* @__PURE__ */ o.default.createElement(I.default, null));
    };
  }(Ze)), Ze;
}
var gt;
function rt() {
  return gt || (gt = 1, function(s) {
    function o(a) {
      "@babel/helpers - typeof";
      return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
        return typeof d;
      } : function(d) {
        return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
      }, o(a);
    }
    Object.defineProperty(s, "__esModule", {
      value: !0
    }), s.default = s.controlBtnStyles = void 0;
    var l = w(ve), k = tt, q = Pe, I = A(Rr()), R = Te, E = A(At), H = A(It), C = A(Tr()), b = X;
    function A(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function O(a) {
      if (typeof WeakMap != "function")
        return null;
      var d = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap();
      return (O = function(x) {
        return x ? g : d;
      })(a);
    }
    function w(a, d) {
      if (!d && a && a.__esModule)
        return a;
      if (a === null || o(a) !== "object" && typeof a != "function")
        return { default: a };
      var g = O(d);
      if (g && g.has(a))
        return g.get(a);
      var P = {}, x = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var M in a)
        if (M !== "default" && Object.prototype.hasOwnProperty.call(a, M)) {
          var B = x ? Object.getOwnPropertyDescriptor(a, M) : null;
          B && (B.get || B.set) ? Object.defineProperty(P, M, B) : P[M] = a[M];
        }
      return P.default = a, g && g.set(a, P), P;
    }
    function h(a, d) {
      var g = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var P = Object.getOwnPropertySymbols(a);
        d && (P = P.filter(function(x) {
          return Object.getOwnPropertyDescriptor(a, x).enumerable;
        })), g.push.apply(g, P);
      }
      return g;
    }
    function v(a) {
      for (var d = 1; d < arguments.length; d++) {
        var g = arguments[d] != null ? arguments[d] : {};
        d % 2 ? h(Object(g), !0).forEach(function(P) {
          S(a, P, g[P]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(g)) : h(Object(g)).forEach(function(P) {
          Object.defineProperty(a, P, Object.getOwnPropertyDescriptor(g, P));
        });
      }
      return a;
    }
    function S(a, d, g) {
      return d = W(d), d in a ? Object.defineProperty(a, d, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : a[d] = g, a;
    }
    function W(a) {
      var d = z(a, "string");
      return o(d) === "symbol" ? d : String(d);
    }
    function z(a, d) {
      if (o(a) !== "object" || a === null)
        return a;
      var g = a[Symbol.toPrimitive];
      if (g !== void 0) {
        var P = g.call(a, d || "default");
        if (o(P) !== "object")
          return P;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (d === "string" ? String : Number)(a);
    }
    function j(a, d) {
      return e(a) || t(a, d) || m(a, d) || f();
    }
    function f() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function m(a, d) {
      if (a) {
        if (typeof a == "string")
          return r(a, d);
        var g = Object.prototype.toString.call(a).slice(8, -1);
        if (g === "Object" && a.constructor && (g = a.constructor.name), g === "Map" || g === "Set")
          return Array.from(a);
        if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g))
          return r(a, d);
      }
    }
    function r(a, d) {
      (d == null || d > a.length) && (d = a.length);
      for (var g = 0, P = new Array(d); g < d; g++)
        P[g] = a[g];
      return P;
    }
    function t(a, d) {
      var g = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
      if (g != null) {
        var P, x, M, B, N = [], V = !0, T = !1;
        try {
          if (M = (g = g.call(a)).next, d === 0) {
            if (Object(g) !== g)
              return;
            V = !1;
          } else
            for (; !(V = (P = M.call(g)).done) && (N.push(P.value), N.length !== d); V = !0)
              ;
        } catch (_) {
          T = !0, x = _;
        } finally {
          try {
            if (!V && g.return != null && (B = g.return(), Object(B) !== B))
              return;
          } finally {
            if (T)
              throw x;
          }
        }
        return N;
      }
    }
    function e(a) {
      if (Array.isArray(a))
        return a;
    }
    var n = R.config.defaultColor, i = R.config.defaultGradient, p = function(d) {
      var g = d.hideEyeDrop, P = d.hideAdvancedSliders, x = d.hideColorGuide, M = d.hideInputType, B = d.hideColorTypeBtns, N = d.hideGradientControls, V = d.hideGradientType, T = d.hideGradientAngle, _ = d.hideGradientStop, L = (0, q.usePicker)(), K = L.isGradient, Y = L.internalOnChange, J = L.previousColors, G = L.previousGraidents, F = L.handleChange, le = (0, l.useState)(!1), fe = j(le, 2), ge = fe[0], Ce = fe[1], Se = (0, l.useState)(!1), te = j(Se, 2), $ = te[0], Z = te[1], re = (0, l.useState)(!1), ee = j(re, 2), ne = ee[0], pe = ee[1], D = g && P && x && M, U = (J == null ? void 0 : J[0]) || n, Q = (G == null ? void 0 : G[0]) || i, ae = function() {
        Y(U);
      }, ue = function() {
        Y(Q);
      }, ce = g && P && x && M;
      return /* @__PURE__ */ l.default.createElement("div", {
        style: {
          paddingTop: 12,
          paddingBottom: 4
        }
      }, /* @__PURE__ */ l.default.createElement("div", {
        style: v(v(v({
          width: "100%"
        }, b.df), b.jsb), b.ac)
      }, /* @__PURE__ */ l.default.createElement("div", {
        style: v(v(v(v({
          height: 28,
          background: B ? "" : "#e9e9f5",
          borderRadius: 6,
          padding: 2
        }, b.df), b.jc), b.ac), b.borderBox)
      }, !B && /* @__PURE__ */ l.default.createElement(l.default.Fragment, null, /* @__PURE__ */ l.default.createElement("div", {
        style: v(v(v(v({}, b.controlBtn), c(!K)), b.df), b.ac),
        onClick: ae
      }, "Solid"), /* @__PURE__ */ l.default.createElement("div", {
        style: v(v(v(v({}, b.controlBtn), c(K)), b.df), b.ac),
        onClick: ue
      }, "Gradient"))), !ce && /* @__PURE__ */ l.default.createElement("div", {
        style: v(v(v(v({}, b.ac), b.jfe), {}, {
          height: 28,
          background: "#e9e9f5",
          borderRadius: 6,
          padding: 2,
          display: D ? "none" : ""
        }, b.df), b.borderBox)
      }, !g && /* @__PURE__ */ l.default.createElement(I.default, {
        onSelect: F,
        buttonStyle: {
          width: 30,
          height: 24,
          borderRadius: 4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }), /* @__PURE__ */ l.default.createElement("div", {
        style: v(v(v({
          width: 30
        }, c(ge)), {}, {
          height: 24,
          borderRadius: 4,
          display: P ? "none" : "flex"
        }, b.jc), b.ac),
        onClick: function() {
          return Ce(!ge);
        }
      }, /* @__PURE__ */ l.default.createElement(k.SlidersIcon, {
        color: ge ? "#568CF5" : ""
      })), /* @__PURE__ */ l.default.createElement("div", {
        style: v(v(v({
          width: 30
        }, c($)), {}, {
          height: 24,
          borderRadius: 4,
          display: x ? "none" : "flex"
        }, b.jc), b.ac),
        onClick: function() {
          return Z(!$);
        }
      }, /* @__PURE__ */ l.default.createElement(k.PaletteIcon, {
        color: $ ? "#568CF5" : ""
      })), /* @__PURE__ */ l.default.createElement("div", {
        style: v(v(v(v({
          width: 30
        }, c(ne)), {}, {
          height: 24,
          borderRadius: 4,
          display: M ? "none" : "flex"
        }, b.jc), b.ac), b.psRl),
        onClick: function() {
          return pe(!ne);
        }
      }, /* @__PURE__ */ l.default.createElement(k.InputsIcon, {
        color: ne ? "#568CF5" : ""
      }), /* @__PURE__ */ l.default.createElement(y, {
        openInputType: ne,
        setOpenInputType: pe
      })))), !P && /* @__PURE__ */ l.default.createElement(E.default, {
        openAdvanced: ge
      }), !x && /* @__PURE__ */ l.default.createElement(H.default, {
        openComparibles: $
      }), K && !N && /* @__PURE__ */ l.default.createElement(C.default, {
        hideGradientType: V,
        hideGradientAngle: T,
        hideGradientStop: _
      }));
    }, u = p;
    s.default = u;
    var y = function(d) {
      var g = d.openInputType, P = d.setOpenInputType, x = (0, q.usePicker)(), M = x.inputType, B = x.setInputType, N = g ? "visibility 0ms linear" : "visibility 100ms linear 150ms", V = g ? "z-index 0ms linear" : "z-index 100ms linear 150ms", T = g ? "opacity 120ms linear" : "opacity 150ms linear 50ms", _ = function(K, Y) {
        g && (K.stopPropagation(), B(Y), P(!1));
      };
      return /* @__PURE__ */ l.default.createElement("div", {
        style: v({
          visibility: g ? "visible" : "hidden",
          zIndex: g ? "" : -100,
          opacity: g ? 1 : 0,
          transition: "".concat(T, ", ").concat(N, ", ").concat(V)
        }, b.inputDropdown)
      }, /* @__PURE__ */ l.default.createElement("div", {
        style: v(v(v(v(v({}, b.df), b.ac), b.psRl), b.controlBtn), c(M === "rgb")),
        onClick: function(K) {
          return _(K, "rgb");
        }
      }, "RGB"), /* @__PURE__ */ l.default.createElement("div", {
        style: v(v(v(v({}, b.df), b.ac), b.controlBtn), c(M === "hsl")),
        onClick: function(K) {
          return _(K, "hsl");
        }
      }, "HSL"), /* @__PURE__ */ l.default.createElement("div", {
        style: v(v(v(v({}, b.df), b.ac), b.controlBtn), c(M === "hsv")),
        onClick: function(K) {
          return _(K, "hsv");
        }
      }, "HSV"), /* @__PURE__ */ l.default.createElement("div", {
        style: v(v(v(v({}, b.df), b.ac), b.controlBtn), c(M === "cmyk")),
        onClick: function(K) {
          return _(K, "cmyk");
        }
      }, "CMYK"));
    }, c = function(d) {
      return {
        background: d ? "white" : "rgba(255,255,255,0)",
        color: d ? "#568CF5" : "rgb(86,86,86)",
        boxShadow: d ? "1px 1px 3px rgba(0,0,0,.2)" : "1px 1px 3px rgba(0,0,0,0)"
      };
    };
    s.controlBtnStyles = c;
  }(Ye)), Ye;
}
var Rt = {};
(function(s) {
  function o(t) {
    "@babel/helpers - typeof";
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
      return typeof e;
    } : function(e) {
      return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, o(t);
  }
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = s.Handle = void 0;
  var l = E(ve), k = je(), q = Pe, I = X;
  function R(t) {
    if (typeof WeakMap != "function")
      return null;
    var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
    return (R = function(p) {
      return p ? n : e;
    })(t);
  }
  function E(t, e) {
    if (!e && t && t.__esModule)
      return t;
    if (t === null || o(t) !== "object" && typeof t != "function")
      return { default: t };
    var n = R(e);
    if (n && n.has(t))
      return n.get(t);
    var i = {}, p = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var u in t)
      if (u !== "default" && Object.prototype.hasOwnProperty.call(t, u)) {
        var y = p ? Object.getOwnPropertyDescriptor(t, u) : null;
        y && (y.get || y.set) ? Object.defineProperty(i, u, y) : i[u] = t[u];
      }
    return i.default = t, n && n.set(t, i), i;
  }
  function H(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(t);
      e && (i = i.filter(function(p) {
        return Object.getOwnPropertyDescriptor(t, p).enumerable;
      })), n.push.apply(n, i);
    }
    return n;
  }
  function C(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e] != null ? arguments[e] : {};
      e % 2 ? H(Object(n), !0).forEach(function(i) {
        b(t, i, n[i]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : H(Object(n)).forEach(function(i) {
        Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
      });
    }
    return t;
  }
  function b(t, e, n) {
    return e = A(e), e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
  }
  function A(t) {
    var e = O(t, "string");
    return o(e) === "symbol" ? e : String(e);
  }
  function O(t, e) {
    if (o(t) !== "object" || t === null)
      return t;
    var n = t[Symbol.toPrimitive];
    if (n !== void 0) {
      var i = n.call(t, e || "default");
      if (o(i) !== "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (e === "string" ? String : Number)(t);
  }
  function w(t, e) {
    return z(t) || W(t, e) || v(t, e) || h();
  }
  function h() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function v(t, e) {
    if (t) {
      if (typeof t == "string")
        return S(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
        return Array.from(t);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return S(t, e);
    }
  }
  function S(t, e) {
    (e == null || e > t.length) && (e = t.length);
    for (var n = 0, i = new Array(e); n < e; n++)
      i[n] = t[n];
    return i;
  }
  function W(t, e) {
    var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (n != null) {
      var i, p, u, y, c = [], a = !0, d = !1;
      try {
        if (u = (n = n.call(t)).next, e === 0) {
          if (Object(n) !== n)
            return;
          a = !1;
        } else
          for (; !(a = (i = u.call(n)).done) && (c.push(i.value), c.length !== e); a = !0)
            ;
      } catch (g) {
        d = !0, p = g;
      } finally {
        try {
          if (!a && n.return != null && (y = n.return(), Object(y) !== y))
            return;
        } finally {
          if (d)
            throw p;
        }
      }
      return c;
    }
  }
  function z(t) {
    if (Array.isArray(t))
      return t;
  }
  var j = function() {
    var e = (0, q.usePicker)(), n = e.currentColor, i = e.addPoint, p = e.colors, u = e.value, y = e.handleGradient, c = e.squareSize, a = e.deletePoint, d = e.isGradient, g = e.selectedColor, P = e.inFocus, x = e.setInFocus, M = (0, l.useState)(!1), B = w(M, 2), N = B[0], V = B[1];
    function T(G) {
      return G.replace(/(radial|linear)-gradient\([^,]+,/, "linear-gradient(90deg,");
    }
    (0, l.useEffect)(function() {
      var G, F, le = (G = window) === null || G === void 0 || (F = G.document) === null || F === void 0 ? void 0 : F.getElementById("gradient-handle-".concat(g));
      le.focus();
    }, [g]);
    var _ = function() {
      V(!1);
    }, L = function(F) {
      N || (i(F), V(!0));
    }, K = function(F) {
      N && y(n, (0, k.getHandleValue)(F));
    }, Y = function(F) {
      d && F.keyCode === 8 && P === "gpoint" && a();
    }, J = function() {
      _();
    };
    return (0, l.useEffect)(function() {
      var G;
      return window.addEventListener("mouseup", J), (G = window) === null || G === void 0 || G.addEventListener("keydown", Y), function() {
        var F;
        window.removeEventListener("mouseup", J), (F = window) === null || F === void 0 || F.removeEventListener("keydown", Y);
      };
    }), /* @__PURE__ */ l.default.createElement("div", {
      style: C(C(C({
        width: "100%"
      }, I.psRl), I.borderBox), {}, {
        marginTop: 17,
        marginBottom: 4
      }),
      id: "gradient-bar"
    }, /* @__PURE__ */ l.default.createElement("div", {
      style: {
        width: c,
        height: 14,
        backgroundImage: T(u),
        borderRadius: 10
      },
      onMouseDown: function(F) {
        return L(F);
      },
      onMouseMove: function(F) {
        return K(F);
      }
    }), p == null ? void 0 : p.map(function(G, F) {
      return /* @__PURE__ */ l.default.createElement(m, {
        i: F,
        left: G.left,
        key: "".concat(F, "-").concat(G),
        setInFocus: x,
        setDragging: V
      });
    }));
  }, f = j;
  s.default = f;
  var m = function(e) {
    var n = e.left, i = e.i, p = e.setDragging, u = e.setInFocus, y = (0, q.usePicker)(), c = y.setSelectedColor, a = y.selectedColor, d = y.squareSize, g = a === i, P = (d - 18) / 100, x = function(V) {
      V.stopPropagation(), c(i), p(!0);
    }, M = function() {
      u("gpoint"), c(i);
    }, B = function() {
      u(null);
    };
    return /* @__PURE__ */ l.default.createElement("div", {
      tabIndex: 0,
      onBlur: B,
      onFocus: M,
      id: "gradient-handle-".concat(i),
      onMouseDown: function(V) {
        return x(V);
      },
      style: C({
        left: n * P
      }, I.gradientHandleWrap)
    }, /* @__PURE__ */ l.default.createElement("div", {
      style: C(C(C(C(C({}, r(g)), I.gradientHandle), I.df), I.jc), I.ac)
    }, g && /* @__PURE__ */ l.default.createElement("div", {
      style: {
        width: 5,
        height: 5,
        borderRadius: "50%",
        background: "white"
      }
    })));
  };
  s.Handle = m;
  var r = function(e) {
    return {
      boxShadow: e ? "0px 0px 5px 1px rgba(86, 140, 245,.95)" : "",
      border: e ? "2px solid white" : "2px solid rgba(255,255,255,.75)"
    };
  };
})(Rt);
(function(s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = void 0;
  var o = b(ve), l = b(St), k = b(Ot), q = b(Pt), I = b(_t), R = b(Et), E = b(rt()), H = b(Rt), C = Pe;
  function b(w) {
    return w && w.__esModule ? w : { default: w };
  }
  var A = function(h) {
    var v = h.hideControls, S = h.hideInputs, W = h.hidePresets, z = h.hideOpacity, j = h.hideHue, f = h.presets, m = h.hideEyeDrop, r = h.hideAdvancedSliders, t = h.hideColorGuide, e = h.hideInputType, n = h.hideColorTypeBtns, i = h.hideGradientType, p = h.hideGradientAngle, u = h.hideGradientStop, y = h.hideGradientControls, c = (0, C.usePicker)(), a = c.isGradient;
    return /* @__PURE__ */ o.default.createElement("div", {
      style: {
        userSelect: "none"
      },
      id: "rbgcp-wrapper"
    }, /* @__PURE__ */ o.default.createElement(q.default, null), !v && /* @__PURE__ */ o.default.createElement(E.default, {
      hideEyeDrop: m,
      hideAdvancedSliders: r,
      hideColorGuide: t,
      hideInputType: e,
      hideColorTypeBtns: n,
      hideGradientControls: y,
      hideGradientType: i,
      hideGradientAngle: p,
      hideGradientStop: u
    }), a && /* @__PURE__ */ o.default.createElement(H.default, null), !j && /* @__PURE__ */ o.default.createElement(l.default, null), !z && /* @__PURE__ */ o.default.createElement(I.default, null), !S && /* @__PURE__ */ o.default.createElement(k.default, null), !W && /* @__PURE__ */ o.default.createElement(R.default, {
      presets: f
    }));
  }, O = A;
  s.default = O;
})(wt);
var Ne = {};
Object.defineProperty(Ne, "__esModule", {
  value: !0
});
Ne.useColorPicker = void 0;
var ht = ve, ze = je(), Oe = xe(), xr = De, Tt = Te;
function We(s) {
  "@babel/helpers - typeof";
  return We = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, We(s);
}
function Je(s) {
  return Gr(s) || Mr(s) || xt(s) || Dr();
}
function Dr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mr(s) {
  if (typeof Symbol < "u" && s[Symbol.iterator] != null || s["@@iterator"] != null)
    return Array.from(s);
}
function Gr(s) {
  if (Array.isArray(s))
    return Qe(s);
}
function Hr(s, o) {
  return jr(s) || Wr(s, o) || xt(s, o) || Lr();
}
function Lr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xt(s, o) {
  if (s) {
    if (typeof s == "string")
      return Qe(s, o);
    var l = Object.prototype.toString.call(s).slice(8, -1);
    if (l === "Object" && s.constructor && (l = s.constructor.name), l === "Map" || l === "Set")
      return Array.from(s);
    if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
      return Qe(s, o);
  }
}
function Qe(s, o) {
  (o == null || o > s.length) && (o = s.length);
  for (var l = 0, k = new Array(o); l < o; l++)
    k[l] = s[l];
  return k;
}
function Wr(s, o) {
  var l = s == null ? null : typeof Symbol < "u" && s[Symbol.iterator] || s["@@iterator"];
  if (l != null) {
    var k, q, I, R, E = [], H = !0, C = !1;
    try {
      if (I = (l = l.call(s)).next, o === 0) {
        if (Object(l) !== l)
          return;
        H = !1;
      } else
        for (; !(H = (k = I.call(l)).done) && (E.push(k.value), E.length !== o); H = !0)
          ;
    } catch (b) {
      C = !0, q = b;
    } finally {
      try {
        if (!H && l.return != null && (R = l.return(), Object(R) !== R))
          return;
      } finally {
        if (C)
          throw q;
      }
    }
    return E;
  }
}
function jr(s) {
  if (Array.isArray(s))
    return s;
}
function mt(s, o) {
  var l = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var k = Object.getOwnPropertySymbols(s);
    o && (k = k.filter(function(q) {
      return Object.getOwnPropertyDescriptor(s, q).enumerable;
    })), l.push.apply(l, k);
  }
  return l;
}
function ke(s) {
  for (var o = 1; o < arguments.length; o++) {
    var l = arguments[o] != null ? arguments[o] : {};
    o % 2 ? mt(Object(l), !0).forEach(function(k) {
      Br(s, k, l[k]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(l)) : mt(Object(l)).forEach(function(k) {
      Object.defineProperty(s, k, Object.getOwnPropertyDescriptor(l, k));
    });
  }
  return s;
}
function Br(s, o, l) {
  return o = qr(o), o in s ? Object.defineProperty(s, o, { value: l, enumerable: !0, configurable: !0, writable: !0 }) : s[o] = l, s;
}
function qr(s) {
  var o = Vr(s, "string");
  return We(o) === "symbol" ? o : String(o);
}
function Vr(s, o) {
  if (We(s) !== "object" || s === null)
    return s;
  var l = s[Symbol.toPrimitive];
  if (l !== void 0) {
    var k = l.call(s, o || "default");
    if (We(k) !== "object")
      return k;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(s);
}
var $r = Tt.config.defaultColor, zr = Tt.config.defaultGradient, Le = Re, Nr = function(o, l) {
  (!o || !l) && console.log("RBGCP ERROR - YOU MUST PASS A VALUE AND CALLBACK TO THE useColorPicker HOOK");
  var k = o == null ? void 0 : o.includes("gradient"), q = (0, ze.getGradientType)(o), I = (0, ze.getDegrees)(o), R = q === "linear-gradient" ? "".concat(I, "deg") : "circle", E = (0, Oe.getColors)(o), H = E == null ? void 0 : E.map(function(te, $) {
    return ke(ke({}, te), {}, {
      index: $
    });
  }), C = (H == null ? void 0 : H.filter(function(te) {
    return (0, ze.isUpperCase)(te.value);
  })[0]) || H[0], b = C == null ? void 0 : C.value, A = C == null ? void 0 : C.index, O = C == null ? void 0 : C.left, w = (0, ht.useState)([]), h = Hr(w, 2), v = h[0], S = h[1], W = function() {
    if (o)
      return k ? {
        isGradient: !0,
        gradientType: q,
        degrees: R,
        colors: E == null ? void 0 : E.map(function($) {
          var Z;
          return ke(ke({}, $), {}, {
            value: (Z = $.value) === null || Z === void 0 ? void 0 : Z.toLowerCase()
          });
        })
      } : {
        isGradient: !1,
        gradientType: null,
        degrees: null,
        colors: E == null ? void 0 : E.map(function($) {
          var Z;
          return ke(ke({}, $), {}, {
            value: (Z = $.value) === null || Z === void 0 ? void 0 : Z.toLowerCase()
          });
        })
      };
    console.log("RBGCP ERROR - YOU MUST PASS A VALUE AND CALLBACK TO THE useColorPicker HOOK");
  }, z = Le(b), j = z.toRgb(), f = j.r, m = j.g, r = j.b, t = j.a, e = z.toHsl(), n = e.h, i = e.s, p = e.l;
  (0, ht.useEffect)(function() {
    var te;
    (te = Le(b)) !== null && te !== void 0 && te.isValid() && v[0] !== b && S([b].concat(Je(v == null ? void 0 : v.slice(0, 19))));
  }, [b, v]);
  var u = function() {
    var $ = o.split(/,(.+)/)[1];
    l("linear-gradient(90deg, ".concat($));
  }, y = function() {
    var $ = o.split(/,(.+)/)[1];
    l("radial-gradient(circle, ".concat($));
  }, c = function($) {
    var Z = o.split(/,(.+)/)[1];
    l("linear-gradient(".concat((0, Oe.formatInputValues)($, 0, 360), "deg, ").concat(Z)), q !== "linear-gradient" && console.log("Warning: you are updating degrees when the gradient type is not linear. This will change the gradients type which may be undesired");
  }, a = function($) {
    var Z = $ || $r;
    l(Z);
  }, d = function($) {
    var Z = $ || zr;
    l(Z);
  }, g = function($) {
    var Z = $.sort(function(ee, ne) {
      return ee.left - ne.left;
    }), re = Z == null ? void 0 : Z.map(function(ee) {
      return "".concat(ee == null ? void 0 : ee.value, " ").concat(ee.left, "%");
    });
    l("".concat(q, "(").concat(R, ", ").concat(re.join(", "), ")"));
  }, P = function($) {
    var Z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : O, re = E == null ? void 0 : E.filter(function(ne) {
      return !(0, ze.isUpperCase)(ne.value);
    }), ee = [{
      value: $.toUpperCase(),
      left: Z
    }].concat(Je(re));
    g(ee);
  }, x = function($) {
    k ? P($) : l($);
  }, M = function($) {
    var Z = (0, Oe.formatInputValues)($, 0, 255);
    x("rgba(".concat(Z, ", ").concat(m, ", ").concat(r, ", ").concat(t, ")"));
  }, B = function($) {
    var Z = (0, Oe.formatInputValues)($, 0, 255);
    x("rgba(".concat(f, ", ").concat(Z, ", ").concat(r, ", ").concat(t, ")"));
  }, N = function($) {
    var Z = (0, Oe.formatInputValues)($, 0, 255);
    x("rgba(".concat(f, ", ").concat(m, ", ").concat(Z, ", ").concat(t, ")"));
  }, V = function($) {
    var Z = (0, Oe.formatInputValues)($, 0, 100);
    x("rgba(".concat(f, ", ").concat(m, ", ").concat(r, ", ").concat(Z / 100, ")"));
  }, T = function($) {
    var Z = (0, Oe.formatInputValues)($, 0, 360), re = Le({
      h: Z,
      s: i,
      l: p
    }), ee = re.toRgb(), ne = ee.r, pe = ee.g, D = ee.b;
    x("rgba(".concat(ne, ", ").concat(pe, ", ").concat(D, ", ").concat(t, ")"));
  }, _ = function($) {
    var Z = (0, Oe.formatInputValues)($, 0, 100), re = Le({
      h: n,
      s: Z / 100,
      l: p
    }), ee = re.toRgb(), ne = ee.r, pe = ee.g, D = ee.b;
    x("rgba(".concat(ne, ", ").concat(pe, ", ").concat(D, ", ").concat(t, ")"));
  }, L = function($) {
    var Z = (0, Oe.formatInputValues)($, 0, 100), re = Le({
      h: n,
      s: i,
      l: Z / 100
    });
    if (re != null && re.isValid()) {
      var ee = re.toRgb(), ne = ee.r, pe = ee.g, D = ee.b;
      x("rgba(".concat(ne, ", ").concat(pe, ", ").concat(D, ", ").concat(t, ")"));
    } else
      console.log("The new color was invalid, perhaps the lightness you passed in was a decimal? Please pass the new value between 0 - 100");
  }, K = function() {
    return z.toHslString();
  }, Y = function() {
    return z.toHsvString();
  }, J = function() {
    return z.toHexString();
  }, G = function() {
    var $ = (0, xr.rgb2cmyk)(f, m, r), Z = $.c, re = $.m, ee = $.y, ne = $.k;
    return "cmyk(".concat(Z, ", ").concat(re, ", ").concat(ee, ", ").concat(ne, ")");
  }, F = function($) {
    if (k) {
      var Z = E == null ? void 0 : E.map(function(re, ee) {
        return ke(ke({}, re), {}, {
          value: ee === $ ? (0, Oe.high)(re) : (0, Oe.low)(re)
        });
      });
      g(Z);
    } else
      console.log("This function is only relevant when the picker is in gradient mode");
  }, le = function($) {
    var Z = [].concat(Je(E.map(function(re) {
      return ke(ke({}, re), {}, {
        value: (0, Oe.low)(re)
      });
    })), [{
      value: b,
      left: $
    }]);
    g(Z), $ || console.log("You did not pass a stop value (left amount) for the new color point so it defaulted to 50");
  }, fe = function($) {
    if ((E == null ? void 0 : E.length) > 2) {
      var Z = $ || A, re = E == null ? void 0 : E.filter(function(ee, ne) {
        return ne !== Z;
      });
      g(re), $ || console.log("You did not pass in the index of the point you wanted to delete so the function default to the currently selected point");
    } else
      console.log("A gradient must have atleast two colors, disable your delete button when necessary");
  }, ge = function($) {
    P(b, (0, Oe.formatInputValues)($, 0, 100));
  }, Ce = [f, m, r, t], Se = [n, i, p];
  return {
    setLinear: u,
    setRadial: y,
    setDegrees: c,
    setSolid: a,
    setGradient: d,
    setR: M,
    setG: B,
    setB: N,
    setA: V,
    setHue: T,
    setSaturation: _,
    setLightness: L,
    valueToHSL: K,
    valueToHSV: Y,
    valueToHex: J,
    valueToCmyk: G,
    setSelectedPoint: F,
    addPoint: le,
    deletePoint: fe,
    selectedPoint: A,
    isGradient: k,
    gradientType: q,
    degrees: I,
    setPointLeft: ge,
    currentLeft: O,
    rgbaArr: Ce,
    hslArr: Se,
    previousColors: v,
    getGradientObject: W
  };
};
Ne.useColorPicker = Nr;
(function(s) {
  function o(t) {
    "@babel/helpers - typeof";
    return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
      return typeof e;
    } : function(e) {
      return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, o(t);
  }
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  var l = {};
  s.default = void 0;
  var k = C(ve), q = E(Pe), I = E(wt), R = Ne;
  Object.keys(R).forEach(function(t) {
    t === "default" || t === "__esModule" || Object.prototype.hasOwnProperty.call(l, t) || t in s && s[t] === R[t] || Object.defineProperty(s, t, {
      enumerable: !0,
      get: function() {
        return R[t];
      }
    });
  });
  function E(t) {
    return t && t.__esModule ? t : { default: t };
  }
  function H(t) {
    if (typeof WeakMap != "function")
      return null;
    var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
    return (H = function(p) {
      return p ? n : e;
    })(t);
  }
  function C(t, e) {
    if (!e && t && t.__esModule)
      return t;
    if (t === null || o(t) !== "object" && typeof t != "function")
      return { default: t };
    var n = H(e);
    if (n && n.has(t))
      return n.get(t);
    var i = {}, p = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var u in t)
      if (u !== "default" && Object.prototype.hasOwnProperty.call(t, u)) {
        var y = p ? Object.getOwnPropertyDescriptor(t, u) : null;
        y && (y.get || y.set) ? Object.defineProperty(i, u, y) : i[u] = t[u];
      }
    return i.default = t, n && n.set(t, i), i;
  }
  function b(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(t);
      e && (i = i.filter(function(p) {
        return Object.getOwnPropertyDescriptor(t, p).enumerable;
      })), n.push.apply(n, i);
    }
    return n;
  }
  function A(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e] != null ? arguments[e] : {};
      e % 2 ? b(Object(n), !0).forEach(function(i) {
        O(t, i, n[i]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function(i) {
        Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
      });
    }
    return t;
  }
  function O(t, e, n) {
    return e = w(e), e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
  }
  function w(t) {
    var e = h(t, "string");
    return o(e) === "symbol" ? e : String(e);
  }
  function h(t, e) {
    if (o(t) !== "object" || t === null)
      return t;
    var n = t[Symbol.toPrimitive];
    if (n !== void 0) {
      var i = n.call(t, e || "default");
      if (o(i) !== "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (e === "string" ? String : Number)(t);
  }
  function v(t, e) {
    return f(t) || j(t, e) || W(t, e) || S();
  }
  function S() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function W(t, e) {
    if (t) {
      if (typeof t == "string")
        return z(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
        return Array.from(t);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return z(t, e);
    }
  }
  function z(t, e) {
    (e == null || e > t.length) && (e = t.length);
    for (var n = 0, i = new Array(e); n < e; n++)
      i[n] = t[n];
    return i;
  }
  function j(t, e) {
    var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (n != null) {
      var i, p, u, y, c = [], a = !0, d = !1;
      try {
        if (u = (n = n.call(t)).next, e === 0) {
          if (Object(n) !== n)
            return;
          a = !1;
        } else
          for (; !(a = (i = u.call(n)).done) && (c.push(i.value), c.length !== e); a = !0)
            ;
      } catch (g) {
        d = !0, p = g;
      } finally {
        try {
          if (!a && n.return != null && (y = n.return(), Object(y) !== y))
            return;
        } finally {
          if (d)
            throw p;
        }
      }
      return c;
    }
  }
  function f(t) {
    if (Array.isArray(t))
      return t;
  }
  function m(t) {
    var e = t.value, n = e === void 0 ? "rgba(175, 51, 242, 1)" : e, i = t.onChange, p = i === void 0 ? function() {
    } : i, u = t.hideControls, y = u === void 0 ? !1 : u, c = t.hideInputs, a = c === void 0 ? !1 : c, d = t.hideOpacity, g = d === void 0 ? !1 : d, P = t.hidePresets, x = P === void 0 ? !1 : P, M = t.hideHue, B = M === void 0 ? !1 : M, N = t.presets, V = N === void 0 ? [] : N, T = t.hideEyeDrop, _ = T === void 0 ? !1 : T, L = t.hideAdvancedSliders, K = L === void 0 ? !1 : L, Y = t.hideColorGuide, J = Y === void 0 ? !1 : Y, G = t.hideInputType, F = G === void 0 ? !1 : G, le = t.hideColorTypeBtns, fe = le === void 0 ? !1 : le, ge = t.hideGradientType, Ce = ge === void 0 ? !1 : ge, Se = t.hideGradientAngle, te = Se === void 0 ? !1 : Se, $ = t.hideGradientStop, Z = $ === void 0 ? !1 : $, re = t.hideGradientControls, ee = re === void 0 ? !1 : re, ne = t.width, pe = ne === void 0 ? 294 : ne, D = t.height, U = D === void 0 ? 294 : D, Q = t.style, ae = Q === void 0 ? {} : Q, ue = t.className, ce = (0, k.useRef)(null), he = (0, k.useState)({}), we = v(he, 2), me = we[0], Ie = we[1];
    return (0, k.useEffect)(function() {
      var Ae;
      Ie(ce == null || (Ae = ce.current) === null || Ae === void 0 ? void 0 : Ae.getBoundingClientRect());
    }, []), /* @__PURE__ */ k.default.createElement("div", {
      ref: ce,
      style: A(A({}, ae), {}, {
        width: pe
      }),
      className: ue
    }, /* @__PURE__ */ k.default.createElement(q.default, {
      bounds: me,
      value: n,
      onChange: p,
      squareSize: pe,
      squareHeight: U,
      hideOpacity: g
    }, /* @__PURE__ */ k.default.createElement(I.default, {
      hideControls: y,
      hideInputs: a,
      hidePresets: x,
      hideOpacity: g,
      hideHue: B,
      presets: V,
      hideEyeDrop: _,
      hideAdvancedSliders: K,
      hideColorGuide: J,
      hideInputType: F,
      hideColorTypeBtns: fe,
      hideGradientType: Ce,
      hideGradientAngle: te,
      hideGradientStop: Z,
      hideGradientControls: ee
    })));
  }
  var r = m;
  s.default = r;
})(bt);
const Zr = /* @__PURE__ */ tr(bt);
export {
  Zr as C,
  bt as l
};
